var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _radialGradient;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 431.03,
    height: 560,
    viewBox: "0 0 431.03 560",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "qmiwtqla6c"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3475",
    d: "m137.033 283.379 43.717-25.4a37.551 37.551 0 0 1-11.093-10.307 47.4 47.4 0 0 1-7.173-14.2l-43.715 25.398a47.368 47.368 0 0 0 7.173 14.2 37.52 37.52 0 0 0 11.091 10.309z",
    transform: "translate(-118.769 -233.464)",
    style: {
      fill: "#98a4e0"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "zvbkvqqhkd"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3479",
    d: "m166.867 212.7-43.717 25.409a9.725 9.725 0 0 0-2.367 1.939c-2.154 2.409-3.415 6.064-3.428 10.8a33.929 33.929 0 0 0 1.534 9.783l43.711-25.406a33.877 33.877 0 0 1-1.533-9.783c.013-4.735 1.273-8.39 3.427-10.8a9.735 9.735 0 0 1 2.373-1.942z",
    transform: "translate(-117.355 -212.703)",
    style: {
      fill: "#98a4e0"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ydw8q9lz6e"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3483",
    d: "M162.717 206.485 119 231.89a12.545 12.545 0 0 1 3.876-1.453c3.649-.727 7.98-.008 12.629 2.336l43.717-25.406c-4.65-2.342-8.98-3.061-12.63-2.335a12.527 12.527 0 0 0-3.875 1.453z",
    transform: "translate(-119.001 -204.761)",
    style: {
      fill: "#c6d5fa"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eliv80g7tf"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3486",
    d: "m138.073 240.571 43.717-25.406a1.674 1.674 0 0 0 .749-1.149c.831-3.815 2.715-6.578 5.324-8.1l-43.717 25.4c-2.609 1.517-4.493 4.28-5.323 8.1a1.673 1.673 0 0 1-.75 1.155z",
    transform: "translate(-138.073 -205.921)",
    style: {
      fill: "#c6d5fa"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4l9lwz0ifg"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3490",
    d: "m183.691 199.7-43.716 25.4a12.223 12.223 0 0 1 2.035-.944c4.393-1.573 10.018-.8 16.12 2.724a40.8 40.8 0 0 1 6.512 4.728l43.717-25.4a40.753 40.753 0 0 0-6.513-4.728c-6.1-3.522-11.726-4.3-16.12-2.724a12.3 12.3 0 0 0-2.035.944z",
    transform: "translate(-139.975 -197.98)",
    style: {
      fill: "#c6d5fa"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2ernhyibrh"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3494",
    d: "m167.058 241.706 43.717-25.4a2.027 2.027 0 0 0 .822-1.892c0-.316-.007-.619-.007-.918.024-8.127 2.189-14.407 5.882-18.539a16.624 16.624 0 0 1 4.061-3.327l-43.717 25.4a16.67 16.67 0 0 0-4.061 3.327c-3.693 4.132-5.858 10.412-5.881 18.539 0 .3 0 .6.005.918a2.022 2.022 0 0 1-.821 1.892z",
    transform: "translate(-167.058 -191.625)",
    style: {
      fill: "#98a4e0"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ssxqx2s42i"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3498",
    d: "m261.832 344.526 43.717-25.4a15.368 15.368 0 0 1-9.267 1.862 27.675 27.675 0 0 1-11.2-3.866l-43.716 25.4a27.67 27.67 0 0 0 11.2 3.867 15.372 15.372 0 0 0 9.266-1.863z",
    transform: "translate(-241.363 -317.116)",
    style: {
      fill: "#98a4e0"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7bngdb1y4j"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3503",
    d: "m139.151 265.173-.035 11.433a1.128 1.128 0 0 0 .66.922l.034-11.433a1.126 1.126 0 0 1-.659-.922z",
    transform: "translate(-139.116 -265.173)",
    style: {
      fill: "#dae8fd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ohma5lavtk"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3506",
    d: "m186.963 276.594.037-11.433a1.135 1.135 0 0 1-.669.935l-.034 11.433a1.137 1.137 0 0 0 .666-.935z",
    transform: "translate(-186.294 -265.161)",
    style: {
      fill: "#c6d5fa"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "od7p3asicl"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3511",
    d: "m161.494 278.655-.035 11.432a3.535 3.535 0 0 0 3.208 0l.035-11.432a3.541 3.541 0 0 1-3.208 0z",
    transform: "translate(-161.459 -278.655)",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7pmtgtjbsm"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3525",
    d: "m139.135 253.257-.035 11.433a1.127 1.127 0 0 0 .66.922l.034-11.433a1.124 1.124 0 0 1-.659-.922z",
    transform: "translate(-139.1 -253.257)",
    style: {
      fill: "#dae8fd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6oahzd9qhn"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3528",
    d: "m186.946 264.678.035-11.433a1.136 1.136 0 0 1-.669.936l-.034 11.432a1.133 1.133 0 0 0 .668-.935z",
    transform: "translate(-186.278 -253.245)",
    style: {
      fill: "#c6d5fa"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n709whcu2o"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3533",
    d: "m161.478 266.739-.035 11.433a3.542 3.542 0 0 0 3.208 0l.034-11.433a3.539 3.539 0 0 1-3.207 0z",
    transform: "translate(-161.443 -266.739)",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2kbe27ur8p"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3549",
    d: "m167.351 280.824-.035 11.433a1.126 1.126 0 0 0 .659.922l.035-11.433a1.126 1.126 0 0 1-.659-.922z",
    transform: "translate(-167.316 -280.824)",
    style: {
      fill: "#dae8fd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i42czgi73q"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3552",
    d: "m215.162 292.245.035-11.433a1.134 1.134 0 0 1-.669.935l-.034 11.433a1.135 1.135 0 0 0 .668-.935z",
    transform: "translate(-214.494 -280.812)",
    style: {
      fill: "#c6d5fa"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s3lh594ser"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3557",
    d: "m189.694 294.3-.035 11.434a3.539 3.539 0 0 0 3.207 0l.034-11.434a3.532 3.532 0 0 1-3.206 0z",
    transform: "translate(-189.659 -294.305)",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1rcq2bpz5s"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3571",
    d: "m167.367 268.908-.035 11.433a1.126 1.126 0 0 0 .658.922l.035-11.433a1.126 1.126 0 0 1-.658-.922z",
    transform: "translate(-167.332 -268.908)",
    style: {
      fill: "#dae8fd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3sgvn6vl3t"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3574",
    d: "m215.178 280.329.035-11.433a1.134 1.134 0 0 1-.669.935l-.034 11.433a1.135 1.135 0 0 0 .668-.935z",
    transform: "translate(-214.51 -268.896)",
    style: {
      fill: "#c6d5fa"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "scei4kdocu"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3579",
    d: "m189.71 282.39-.035 11.432a3.535 3.535 0 0 0 3.208 0l.034-11.432a3.539 3.539 0 0 1-3.207 0z",
    transform: "translate(-189.675 -282.39)",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "nmkn7c6cpv"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3593",
    d: "m167.351 256.992-.035 11.433a1.126 1.126 0 0 0 .659.922l.035-11.433a1.126 1.126 0 0 1-.659-.922z",
    transform: "translate(-167.316 -256.992)",
    style: {
      fill: "#dae8fd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3b17vy35ew"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3596",
    d: "m215.162 268.413.035-11.433a1.133 1.133 0 0 1-.669.935l-.034 11.433a1.134 1.134 0 0 0 .668-.935z",
    transform: "translate(-214.494 -256.98)",
    style: {
      fill: "#c6d5fa"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0hcfp9piqx"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3601",
    d: "m189.694 270.474-.035 11.433a3.539 3.539 0 0 0 3.207 0l.035-11.433a3.539 3.539 0 0 1-3.207 0z",
    transform: "translate(-189.659 -270.474)",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mzzjmw5uey"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3615",
    d: "m167.367 245.015-.035 11.432a1.127 1.127 0 0 0 .658.923l.035-11.433a1.126 1.126 0 0 1-.658-.922z",
    transform: "translate(-167.332 -245.015)",
    style: {
      fill: "#dae8fd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7oq7f2dx5z"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3618",
    d: "m215.178 256.436.035-11.436a1.135 1.135 0 0 1-.669.935l-.034 11.433a1.135 1.135 0 0 0 .668-.932z",
    transform: "translate(-214.51 -245.003)",
    style: {
      fill: "#c6d5fa"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e3fkbed99A"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3623",
    d: "m189.71 258.5-.035 11.433a3.535 3.535 0 0 0 3.208 0l.034-11.433a3.533 3.533 0 0 1-3.207 0z",
    transform: "translate(-189.675 -258.496)",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "zw43usr7jB"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3639",
    d: "m193.8 295.889-.035 11.432a1.125 1.125 0 0 0 .66.923l.034-11.433a1.126 1.126 0 0 1-.659-.922z",
    transform: "translate(-193.767 -295.889)",
    style: {
      fill: "#dae8fd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "sjruse0tsC"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3642",
    d: "m241.613 307.31.035-11.433a1.134 1.134 0 0 1-.669.935l-.035 11.433a1.132 1.132 0 0 0 .669-.935z",
    transform: "translate(-240.944 -295.877)",
    style: {
      fill: "#c6d5fa"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e49xmgwhpD"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3647",
    d: "m216.145 309.37-.035 11.43a3.535 3.535 0 0 0 3.208 0l.034-11.433a3.533 3.533 0 0 1-3.207.003z",
    transform: "translate(-216.11 -309.37)",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "60j8ma5acE"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3661",
    d: "m193.8 283.973-.035 11.433a1.125 1.125 0 0 0 .66.922l.034-11.433a1.126 1.126 0 0 1-.659-.922z",
    transform: "translate(-193.767 -283.973)",
    style: {
      fill: "#dae8fd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "utt9yna62F"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3664",
    d: "m241.613 295.394.035-11.433a1.134 1.134 0 0 1-.669.935l-.035 11.433a1.132 1.132 0 0 0 .669-.935z",
    transform: "translate(-240.944 -283.961)",
    style: {
      fill: "#c6d5fa"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "xpx7g57cnG"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3669",
    d: "m216.145 297.455-.035 11.432a3.535 3.535 0 0 0 3.208 0l.034-11.432a3.539 3.539 0 0 1-3.207 0z",
    transform: "translate(-216.11 -297.455)",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pwe17l3urH"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3683",
    d: "m193.818 272.057-.035 11.433a1.126 1.126 0 0 0 .658.922l.035-11.433a1.126 1.126 0 0 1-.658-.922z",
    transform: "translate(-193.783 -272.057)",
    style: {
      fill: "#dae8fd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pxt0k30v7I"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3686",
    d: "m241.629 283.478.035-11.433a1.135 1.135 0 0 1-.669.935l-.035 11.433a1.133 1.133 0 0 0 .669-.935z",
    transform: "translate(-240.96 -272.045)",
    style: {
      fill: "#c6d5fa"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "zkmbbd9noJ"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3691",
    d: "m216.161 285.539-.035 11.433a3.539 3.539 0 0 0 3.207 0l.035-11.433a3.539 3.539 0 0 1-3.207 0z",
    transform: "translate(-216.126 -285.539)",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hlaqcrvajK"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3705",
    d: "m193.8 260.141-.035 11.433a1.125 1.125 0 0 0 .66.922l.034-11.433a1.125 1.125 0 0 1-.659-.922z",
    transform: "translate(-193.767 -260.141)",
    style: {
      fill: "#dae8fd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2hugn5x2iL"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3708",
    d: "m241.613 271.562.035-11.433a1.133 1.133 0 0 1-.669.935l-.035 11.433a1.132 1.132 0 0 0 .669-.935z",
    transform: "translate(-240.944 -260.129)",
    style: {
      fill: "#c6d5fa"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1cbbp9l7bM"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3713",
    d: "m216.145 273.623-.035 11.433a3.541 3.541 0 0 0 3.208 0l.034-11.433a3.539 3.539 0 0 1-3.207 0z",
    transform: "translate(-216.11 -273.623)",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "vgeb7osu1N"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3727",
    d: "m193.818 248.164-.035 11.433a1.127 1.127 0 0 0 .658.922l.035-11.433a1.126 1.126 0 0 1-.658-.922z",
    transform: "translate(-193.783 -248.164)",
    style: {
      fill: "#dae8fd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "arrj4lfnqO"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3730",
    d: "m241.629 259.585.035-11.433a1.134 1.134 0 0 1-.669.935l-.035 11.433a1.134 1.134 0 0 0 .669-.935z",
    transform: "translate(-240.96 -248.152)",
    style: {
      fill: "#c6d5fa"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "xbsra2okgP"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3735",
    d: "m216.161 261.645-.035 11.433a3.532 3.532 0 0 0 3.207 0l.035-11.433a3.532 3.532 0 0 1-3.207 0z",
    transform: "translate(-216.126 -261.645)",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "okr6a6eklQ"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3751",
    d: "m220.543 311.35-.035 11.433a1.126 1.126 0 0 0 .659.922l.035-11.433a1.126 1.126 0 0 1-.659-.922z",
    transform: "translate(-220.508 -311.35)",
    style: {
      fill: "#dae8fd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3lnzep9oyR"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3754",
    d: "m268.354 322.771.035-11.433a1.135 1.135 0 0 1-.669.935l-.035 11.433a1.135 1.135 0 0 0 .669-.935z",
    transform: "translate(-267.685 -311.338)",
    style: {
      fill: "#c6d5fa"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9uit7coi0S"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3759",
    d: "m242.886 324.831-.035 11.433a3.532 3.532 0 0 0 3.207 0l.035-11.433a3.533 3.533 0 0 1-3.207 0z",
    transform: "translate(-242.851 -324.831)",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "oxlcmgjkwT"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3773",
    d: "m220.543 299.434-.035 11.433a1.126 1.126 0 0 0 .659.922l.035-11.433a1.126 1.126 0 0 1-.659-.922z",
    transform: "translate(-220.508 -299.434)",
    style: {
      fill: "#dae8fd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e4mmsifurU"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3776",
    d: "m268.354 310.855.035-11.433a1.135 1.135 0 0 1-.669.935l-.035 11.433a1.135 1.135 0 0 0 .669-.935z",
    transform: "translate(-267.685 -299.422)",
    style: {
      fill: "#c6d5fa"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ldesisfy8V"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3781",
    d: "m242.886 312.915-.035 11.433a3.533 3.533 0 0 0 3.207 0l.035-11.433a3.533 3.533 0 0 1-3.207 0z",
    transform: "translate(-242.851 -312.915)",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "z9q5swh1rW"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3795",
    d: "m220.558 287.518-.034 11.433a1.124 1.124 0 0 0 .658.922l.035-11.433a1.128 1.128 0 0 1-.659-.922z",
    transform: "translate(-220.524 -287.518)",
    style: {
      fill: "#dae8fd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "yiph7xbylX"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3798",
    d: "m268.37 298.939.035-11.433a1.137 1.137 0 0 1-.669.935l-.035 11.433a1.135 1.135 0 0 0 .669-.935z",
    transform: "translate(-267.701 -287.506)",
    style: {
      fill: "#c6d5fa"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q1gg1spe6Y"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3803",
    d: "m242.9 301-.034 11.432a3.532 3.532 0 0 0 3.207 0l.035-11.432a3.541 3.541 0 0 1-3.208 0z",
    transform: "translate(-242.867 -301)",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mgh0xloxdZ"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3817",
    d: "m220.543 275.6-.035 11.433a1.126 1.126 0 0 0 .659.922l.035-11.433a1.125 1.125 0 0 1-.659-.922z",
    transform: "translate(-220.508 -275.602)",
    style: {
      fill: "#dae8fd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "z5mq6jc9yaa"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3820",
    d: "m268.354 287.023.035-11.433a1.136 1.136 0 0 1-.669.936l-.035 11.432a1.135 1.135 0 0 0 .669-.935z",
    transform: "translate(-267.685 -275.59)",
    style: {
      fill: "#c6d5fa"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "tv0awqhhgab"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3825",
    d: "m242.886 289.084-.035 11.433a3.539 3.539 0 0 0 3.207 0l.035-11.433a3.533 3.533 0 0 1-3.207 0z",
    transform: "translate(-242.851 -289.084)",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "sq2nwtxctac"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3885",
    d: "m297.227 263.066 1.241.721a.334.334 0 0 0-.336.034l-1.241-.721a.334.334 0 0 1 .336-.034z",
    transform: "translate(-296.891 -263.035)",
    style: {
      fill: "#3a4648"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "lk26392yqad"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3890",
    d: "m283.274 273.014-1.241-.72a1.043 1.043 0 0 1 .473-.817l1.241.721a1.037 1.037 0 0 0-.473.816z",
    transform: "translate(-282.033 -271.477)",
    style: {
      fill: "#3a4648"
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "z7sg9j6bia",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dffeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01b0f9"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ytk1opx8zae",
    x1: 0.001,
    y1: 0.045,
    x2: 1.261,
    y2: 1.194,
    xlinkHref: "#z7sg9j6bia"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "9a2by5o0faf",
    x1: 1.049,
    y1: -0.631,
    x2: 0.369,
    y2: 0.822,
    xlinkHref: "#z7sg9j6bia"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "nnpo739jdag",
    x1: 0.006,
    y1: -0.262,
    x2: 0.825,
    y2: 1.2,
    xlinkHref: "#z7sg9j6bia"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lwn02c96hah",
    x1: 0.102,
    y1: 0.024,
    x2: 1.001,
    y2: 1.099,
    xlinkHref: "#z7sg9j6bia"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "yw15qjfm6ai",
    x1: 0.5,
    y1: -0.2,
    x2: 0.5,
    y2: 0.798,
    xlinkHref: "#z7sg9j6bia"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "uvsw05syhb",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#01b3f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#015bea"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ok1z7ijpxaj",
    x1: 0.5,
    y1: 0.112,
    x2: 0.5,
    y2: 0.905,
    xlinkHref: "#uvsw05syhb"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ojljp5rxqal",
    x1: 0.5,
    y1: -0.013,
    x2: 0.5,
    y2: 1.112,
    xlinkHref: "#z7sg9j6bia"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "l8drgwiulak",
    cx: -0.495,
    cy: 1.288,
    r: 1.805,
    gradientTransform: "matrix(2.395 0 0 1 -.697 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#419dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#1d4cd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08137a"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3019"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 726",
    style: {
      fill: "none"
    },
    d: "M0 0h431.03v560H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3015",
    transform: "translate(-335.635 -96.106)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 326",
    cx: 213.209,
    cy: 66.485,
    rx: 213.209,
    ry: 66.485,
    transform: "translate(338 360.618)",
    style: {
      opacity: 0.15,
      fill: "#50acff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 325",
    cx: 211.084,
    cy: 65.933,
    rx: 211.084,
    ry: 65.933,
    transform: "translate(340.125 346.089)",
    style: {
      opacity: 0.15,
      fill: "#50acff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 548",
    cx: 207.677,
    cy: 65.933,
    rx: 207.677,
    ry: 65.933,
    transform: "translate(344.814 330.189)",
    style: {
      opacity: 0.411,
      fill: "#50acff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2992"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2993"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2618"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2587",
    style: {
      isolation: "isolate",
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3427",
    d: "M286.457 145.986c-23.59-13.619-43.171-4.505-46.054 20.122a46.4 46.4 0 0 0-5.674-3.884c-6.964-4.02-13.776-5.171-19.183-3.239-4.3 1.536-7.574 4.962-9.457 9.811-15.252-6.961-27.215 1.018-27.266 19.014-.054 19.239 13.521 42.757 30.268 52.426L337.4 314.313c22.232 12.835 40.378 2.5 40.449-23.055s-17.955-56.772-40.187-69.608a49.228 49.228 0 0 0-5.431-2.718c-2.812-27.818-22.241-59.358-45.774-72.946z",
    transform: "translate(333.012 79.605)",
    style: {
      fill: "#909294",
      opacity: 0.167
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3428",
    d: "M272.3 157.473c-22.982-13.269-42.06-4.389-44.869 19.6a45.121 45.121 0 0 0-5.527-3.784c-6.785-3.917-13.422-5.038-18.69-3.156-4.191 1.5-7.379 4.834-9.212 9.559-14.86-6.782-26.515.992-26.565 18.525-.053 18.743 13.173 41.657 29.489 51.077l125 72.17c21.66 12.506 39.339 2.431 39.409-22.462s-17.485-55.302-39.145-67.81a47.869 47.869 0 0 0-5.291-2.649c-2.738-27.103-21.666-57.831-44.599-71.07z",
    transform: "translate(332.047 80.593)",
    style: {
      fill: "#a1a5a9",
      opacity: 0.333
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3429",
    d: "M258.153 168.961c-22.376-12.918-40.948-4.274-43.683 19.086a44.089 44.089 0 0 0-5.382-3.684c-6.6-3.813-13.067-4.9-18.195-3.072-4.08 1.457-7.185 4.707-8.969 9.306-14.467-6.6-25.815.966-25.863 18.036-.052 18.248 12.825 40.556 28.709 49.727l121.7 70.264c21.088 12.175 38.3 2.366 38.368-21.868s-17.031-53.849-38.118-66.024a46.486 46.486 0 0 0-5.152-2.579c-2.668-26.387-21.093-56.304-43.415-69.192z",
    transform: "translate(331.081 81.582)",
    style: {
      opacity: 0.5,
      fill: "#b3b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3430",
    d: "M244 180.449c-21.767-12.568-39.837-4.157-42.5 18.568a42.767 42.767 0 0 0-5.237-3.584c-6.426-3.71-12.712-4.772-17.7-2.989-3.969 1.417-6.99 4.579-8.726 9.054-14.075-6.424-25.113.938-25.161 17.545-.05 17.753 12.478 39.456 27.93 48.377l118.4 68.358c20.514 11.844 37.259 2.3 37.326-21.275s-16.569-52.388-37.084-64.232a45 45 0 0 0-5.012-2.508c-2.59-25.67-20.518-54.776-42.236-67.314z",
    transform: "translate(330.115 82.57)",
    style: {
      fill: "#c4cbd4",
      opacity: 0.667
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3431",
    d: "M229.849 191.936c-21.16-12.216-38.726-4.041-41.312 18.051a41.635 41.635 0 0 0-5.089-3.484c-6.248-3.606-12.359-4.639-17.209-2.905-3.859 1.378-6.794 4.451-8.482 8.8-13.682-6.245-24.413.912-24.459 17.056-.049 17.258 12.129 38.355 27.151 47.028l115.1 66.451c19.943 11.515 36.221 2.238 36.286-20.681s-16.108-50.926-36.05-62.44a43.98 43.98 0 0 0-4.872-2.439c-2.525-24.955-19.953-53.248-41.064-65.437z",
    transform: "translate(329.15 83.559)",
    style: {
      fill: "#d5dee9",
      opacity: 0.833
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3432",
    d: "M215.7 203.423c-20.553-11.866-37.615-3.925-40.126 17.533a40.511 40.511 0 0 0-4.944-3.385c-6.067-3.5-12-4.505-16.714-2.822a13.981 13.981 0 0 0-8.239 8.549c-13.29-6.065-23.714.886-23.758 16.567-.048 16.763 11.781 37.255 26.372 45.678l111.794 64.545c19.371 11.184 35.181 2.174 35.244-20.088s-15.645-49.466-35.015-60.649a42.588 42.588 0 0 0-4.732-2.368c-2.451-24.239-19.382-51.721-39.882-63.56z",
    transform: "translate(328.184 84.547)",
    style: {
      fill: "#e6f1fe"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2588",
    style: {
      isolation: "isolate",
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3433",
    d: "M239.92 179.2v.822a2.49 2.49 0 0 0 1.127 1.952l1.559.9a12.382 12.382 0 0 0 .638 2.025l-1.049.605c-.44.255-.44 1.078 0 1.841l.5.872c.44.762 1.153 1.174 1.594.92l1.1-.637a11.764 11.764 0 0 0 1.467 1.5v1.713a2.492 2.492 0 0 0 1.127 1.953l.712.411c.623.359 1.127.067 1.127-.651v-1.8a3.886 3.886 0 0 0 1.435.092l1.049 1.816c.44.763 1.153 1.174 1.594.92l.5-.291c.44-.254.44-1.078 0-1.84l-1.1-1.908a4.216 4.216 0 0 0 .564-1.368l1.483.856c.623.359 1.127.068 1.127-.651v-.822a2.49 2.49 0 0 0-1.127-1.952l-1.559-.9a12.272 12.272 0 0 0-.638-2.025l1.049-.605c.44-.254.44-1.078 0-1.84l-.5-.872c-.44-.763-1.153-1.175-1.594-.921l-1.1.637a11.767 11.767 0 0 0-1.467-1.5v-1.713a2.49 2.49 0 0 0-1.128-1.952l-.712-.411c-.623-.359-1.127-.068-1.127.65v1.8a3.818 3.818 0 0 0-1.435-.092l-1.049-1.817c-.439-.762-1.153-1.174-1.594-.92l-.5.291c-.44.254-.44 1.078 0 1.84l1.1 1.909a4.2 4.2 0 0 0-.564 1.368l-1.483-.857c-.62-.353-1.126-.063-1.126.652zm5.5 3.421c0-1.774 1.244-2.493 2.78-1.606a6.147 6.147 0 0 1 2.78 4.816c0 1.774-1.245 2.492-2.78 1.606a6.144 6.144 0 0 1-2.78-4.812z",
    transform: "translate(338.196 82.512)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3434",
    d: "M229.116 169.662v.628a1.905 1.905 0 0 0 .861 1.492l1.191.688a9.408 9.408 0 0 0 .487 1.547l-.8.463c-.336.194-.336.823 0 1.406l.384.666c.336.583.882.9 1.218.7l.842-.486a9.032 9.032 0 0 0 1.121 1.145v1.308a1.9 1.9 0 0 0 .86 1.492l.545.314c.475.274.86.052.86-.5v-1.376a2.952 2.952 0 0 0 1.1.071l.8 1.387c.336.583.882.9 1.218.7l.384-.222c.336-.194.336-.823 0-1.406l-.842-1.458a3.208 3.208 0 0 0 .431-1.046l1.134.654c.475.274.861.052.861-.5v-.628a1.905 1.905 0 0 0-.861-1.492l-1.191-.688a9.507 9.507 0 0 0-.487-1.547l.8-.463c.336-.194.336-.823 0-1.406l-.384-.666c-.336-.583-.882-.9-1.218-.7l-.842.486a9.035 9.035 0 0 0-1.121-1.145v-1.308a1.906 1.906 0 0 0-.86-1.492l-.545-.313c-.475-.274-.86-.052-.86.5v1.376a2.953 2.953 0 0 0-1.1-.071l-.8-1.389c-.336-.581-.882-.9-1.218-.7l-.384.222c-.336.194-.336.823 0 1.406l.842 1.458a3.2 3.2 0 0 0-.431 1.046l-1.134-.654c-.477-.27-.861-.048-.861.501zm4.2 2.613c0-1.355.95-1.9 2.124-1.227a4.7 4.7 0 0 1 2.124 3.68c0 1.355-.95 1.9-2.124 1.227a4.7 4.7 0 0 1-2.121-3.679z",
    transform: "translate(337.279 81.808)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3435",
    d: "m240.81 173.45.407.4c.356.349.745.358.87.02l.312-.849a4.1 4.1 0 0 0 .949.459l.389 1.161c.164.486.572.887.911.9l.389.009c.34.008.483-.381.319-.868l-.409-1.219a1.7 1.7 0 0 0 .616-.482l.848.833c.356.349.745.358.87.02l.143-.388a1.35 1.35 0 0 0-.419-1.247l-.891-.875a5.246 5.246 0 0 0-.078-1.14l.81.018c.34.008.484-.381.32-.868l-.187-.558c-.164-.486-.572-.887-.912-.895l-.851-.018a8.514 8.514 0 0 0-.726-1.13l.3-.808a1.349 1.349 0 0 0-.418-1.246l-.408-.4c-.356-.349-.745-.358-.87-.018l-.312.848a4.1 4.1 0 0 0-.949-.459l-.389-1.16c-.163-.487-.572-.888-.911-.9l-.388-.008c-.341-.009-.484.381-.32.867l.409 1.219a1.7 1.7 0 0 0-.616.482l-.848-.833c-.356-.349-.745-.358-.87-.02l-.143.388a1.35 1.35 0 0 0 .419 1.246l.892.875a5.237 5.237 0 0 0 .076 1.14l-.809-.018c-.34-.008-.483.382-.32.868l.188.558c.163.487.571.887.911.895l.851.018a8.512 8.512 0 0 0 .726 1.13l-.3.808a1.35 1.35 0 0 0 .419 1.245zm1.224-2.875A3.334 3.334 0 0 1 241 167.5c.308-.836 1.269-.815 2.148.048a3.33 3.33 0 0 1 1.033 3.077c-.308.835-1.27.813-2.147-.05z",
    transform: "translate(338.009 81.549)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3436",
    d: "M340.277 277.372v11.554a5.379 5.379 0 0 1 2.723 1.815c1.579 1.717 2.481 3.879 2.013 4.831s-2.125.33-3.7-1.389a7.233 7.233 0 0 1-2.131-4.278h-.005v-12.361l-6.609-7.188v14.116a5.385 5.385 0 0 1 2.723 1.815c1.58 1.717 2.48 3.88 2.013 4.831s-2.126.33-3.7-1.388c-1.346-1.465-2.2-3.25-2.128-4.335l-.008-.005v-17.612z",
    transform: "translate(345.962 90.475)",
    style: {
      fill: "#fff",
      isolation: "isolate",
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2592",
    style: {
      isolation: "isolate",
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2591"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2590"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3437",
    d: "M273.244 207.7a3.739 3.739 0 0 0-1.478-1.839c-.63-.364-1.18-.284-1.476.135a1.459 1.459 0 0 0-.23.85 3.781 3.781 0 0 0 1.706 2.957c.942.543 1.708.1 1.708-.986a3.142 3.142 0 0 0-.23-1.117z",
    transform: "translate(340.753 85.202)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2589"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3438",
    d: "m264.221 194.358.844 1.462c1.844-1.065 4.389-.918 7.2.7a20.813 20.813 0 0 1 7.2 7.607l.844-.488a23.265 23.265 0 0 0-8.041-8.5c-3.144-1.808-5.987-1.973-8.047-.781z",
    transform: "translate(340.258 84.181)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3439",
    d: "m266.562 198.394.844 1.462c1.193-.69 2.84-.593 4.657.456a13.47 13.47 0 0 1 4.658 4.923l.844-.488a15.905 15.905 0 0 0-5.5-5.815c-2.149-1.24-4.094-1.353-5.503-.538z",
    transform: "translate(340.457 84.544)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3440",
    d: "m268.9 202.432.844 1.462a2.1 2.1 0 0 1 2.115.205 6.113 6.113 0 0 1 2.117 2.239l.844-.487a8.552 8.552 0 0 0-2.961-3.132 2.933 2.933 0 0 0-2.959-.287z",
    transform: "translate(340.655 84.907)",
    style: {
      fill: "#fff"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2593",
    style: {
      isolation: "isolate",
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3441",
    d: "M353.555 264.411 330.671 251.2v-26.425l22.884 13.212z",
    transform: "translate(345.895 86.826)",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3442",
    d: "m348.948 249.479-5.222 3.3-8.293-16.316-4.761 6.954v6.79l22.884 13.212v-6.607z",
    transform: "translate(345.895 87.818)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3443",
    d: "M348 241.652a6.789 6.789 0 0 0-3.071-5.32c-1.7-.98-3.071-.184-3.071 1.774a6.786 6.786 0 0 0 3.071 5.32c1.695.979 3.071.185 3.071-1.774z",
    transform: "translate(346.844 87.771)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2595",
    style: {
      isolation: "isolate",
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3444",
    d: "m314.29 221.294-23.59-13.617v-36.869l23.588 13.618z",
    transform: "translate(342.504 82.248)",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3445",
    d: "m309.615 188.282-14.914-8.61V175.1l14.914 8.61z",
    transform: "translate(342.843 82.612)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2594"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3446",
    d: "m312.34 194.489-19.97-11.529v-2.54l19.97 11.53z",
    transform: "translate(342.646 83.063)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3447",
    d: "m312.34 198.7-19.97-11.53v-2.54l19.97 11.53z",
    transform: "translate(342.646 83.421)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3448",
    d: "m312.34 202.917-19.97-11.53v-2.54l19.97 11.53z",
    transform: "translate(342.646 83.778)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3449",
    d: "M312.34 207.131 292.37 195.6v-2.54l19.97 11.53z",
    transform: "translate(342.646 84.136)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3450",
    d: "m312.34 211.345-19.97-11.53v-2.54l19.97 11.525z",
    transform: "translate(342.646 84.493)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3451",
    d: "m307.482 212.753-15.112-8.724v-2.54l15.112 8.724z",
    transform: "translate(342.646 84.851)",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2596",
    style: {
      isolation: "isolate",
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3452",
    d: "m318.6 274.1-24.608-14.207v-22.622l9.8 5.658 2.209 4.5 12.6 7.274z",
    transform: "translate(342.784 87.887)",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3453",
    d: "m317.964 249.426-23.411-13.516v1.829l9.188 5.3 2.209 4.506 12.013 6.936z",
    transform: "translate(342.831 87.771)",
    style: {
      opacity: 0.8,
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2597",
    style: {
      isolation: "isolate",
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3454",
    d: "M277.484 162.456v-1.315a9.05 9.05 0 0 0-4.089-7.083c-2.255-1.3-4.09-.243-4.09 2.361v1.315c-.481.052-.8.47-.8 1.163v6.16a3.626 3.626 0 0 0 1.64 2.841l6.506 3.756c.906.523 1.64.1 1.64-.947v-6.16a3.571 3.571 0 0 0-.807-2.091zm-4.089-6.976a6.325 6.325 0 0 1 2.858 4.949v1.048l-5.715-3.3v-1.047c0-1.818 1.281-2.559 2.862-1.649zm.814 10.727v1.872l-1.627-.939v-1.872a3 3 0 0 1-.589-1.654c0-.895.628-1.257 1.4-.81a3.1 3.1 0 0 1 1.4 2.43c.007.542-.229.885-.584.974z",
    transform: "translate(340.621 80.779)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2598",
    style: {
      isolation: "isolate",
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3455",
    d: "m282.269 247.763-23.512-13.574v-19.115l23.512 13.574z",
    transform: "translate(339.794 86.003)",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3456",
    d: "m258.757 215.074 23.512 13.574-11.756 4.252z",
    transform: "translate(339.794 86.003)",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2607",
    style: {
      isolation: "isolate",
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2602"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2599"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3457",
    d: "M321.36 192.4a2.251 2.251 0 0 1-.432-.331 2.7 2.7 0 0 1-.853-2.475c1.094-3.121 3.723-4.437 7.036-3.522 4.846 1.339 9.816 6.99 11.816 13.438.3.964-.014 1.706-.7 1.655a2.536 2.536 0 0 1-1.785-1.838c-1.463-4.717-5.1-8.852-8.647-9.832a3.914 3.914 0 0 0-5.152 2.58c-.188.546-.717.655-1.283.325z",
    transform: "translate(344.991 83.519)",
    style: {
      fill: "#ecf5fe"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2601"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2600"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3458",
    d: "m318.409 187.788 3.465 8.7 3.292-4.913z",
    transform: "translate(344.855 83.688)",
    style: {
      fill: "#ecf5fe"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2606"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2603"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3459",
    d: "M329.913 210.908c-3.722-2.148-7.279-6.594-9.03-11.539-.342-.966-.079-1.757.587-1.768s1.483.765 1.825 1.73c1.568 4.432 5.122 8.315 8.449 9.234a3.919 3.919 0 0 0 5.188-2.686c.227-.692.989-.706 1.7-.031a2.727 2.727 0 0 1 .879 2.475c-1.062 3.227-3.71 4.6-7.086 3.667a10.866 10.866 0 0 1-2.512-1.082z",
    transform: "translate(345.052 84.521)",
    style: {
      fill: "#ecf5fe"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2605"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2604"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3460",
    d: "m340.218 209.971-2.95-8.723-3.791 4.27z",
    transform: "translate(346.133 84.83)",
    style: {
      fill: "#ecf5fe"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2608",
    style: {
      isolation: "isolate",
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3461",
    d: "m289.81 223.807-2.4-1.387v-2.773l2.4 1.386z",
    transform: "translate(342.225 86.392)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3462",
    d: "m218.658 181.672-2.4-1.387v-2.773l2.4 1.386z",
    transform: "translate(336.189 82.817)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3463",
    d: "m257.428 150.111-2.4-1.387v-2.773l2.4 1.387z",
    transform: "translate(339.478 80.139)",
    style: {
      opacity: 0.3,
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3464",
    d: "m362.6 282.083-2.4-1.386v-2.773l2.4 1.387z",
    transform: "translate(348.401 91.336)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3465",
    d: "m309.743 279.469-2.4-1.387v-2.772l2.4 1.387z",
    transform: "translate(343.916 91.114)",
    style: {
      fill: "#eff6fe",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3466",
    d: "m331.759 259.866-2.4-1.386v-2.773l2.4 1.387z",
    transform: "translate(345.784 89.451)",
    style: {
      opacity: 0.3,
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3467",
    d: "m319.151 211.246-2.4-1.387v-2.773l2.4 1.387z",
    transform: "translate(344.715 85.326)",
    style: {
      opacity: 0.1,
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3468",
    d: "m317 310.188 2.58 1.017.409 2.743-2.58-1.017z",
    transform: "translate(344.736 94.073)",
    style: {
      fill: "#eff6fe"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2617",
    style: {
      isolation: "isolate",
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2612"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2609"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3469",
    d: "M185.037 256.262a4.2 4.2 0 0 1-.8-.617c-1.321-1.276-2.032-3.339-1.587-4.608 2.035-5.81 6.933-8.262 13.1-6.558 9.025 2.493 18.277 13.016 22 25.021.558 1.8-.026 3.177-1.3 3.084s-2.765-1.626-3.323-3.423c-2.725-8.784-9.5-16.483-16.1-18.308-4.515-1.248-8.1.549-9.591 4.8-.361 1.017-1.345 1.218-2.399.609z",
    transform: "translate(333.325 88.453)",
    style: {
      fill: "#ecf5fe"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2611"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2610"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3470",
    d: "m179.542 247.669 6.452 16.2 6.131-9.149z",
    transform: "translate(333.073 88.768)",
    style: {
      fill: "#ecf5fe"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2616"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2613"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3471",
    d: "M200.963 290.721c-6.931-4-13.555-12.278-16.814-21.487-.637-1.8-.149-3.274 1.091-3.294s2.762 1.423 3.4 3.223c2.919 8.25 9.536 15.482 15.732 17.194 4.6 1.27 8.211-.6 9.658-5 .424-1.289 1.844-1.315 3.171-.06s2.061 3.32 1.638 4.608c-1.978 6.01-6.909 8.563-13.194 6.827a20.155 20.155 0 0 1-4.682-2.011z",
    transform: "translate(333.44 90.318)",
    style: {
      fill: "#ecf5fe"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2615"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2614"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3472",
    d: "m220.151 288.975-5.493-16.243-7.059 7.952z",
    transform: "translate(335.453 90.895)",
    style: {
      fill: "#ecf5fe"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2951"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2642"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2641",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2621"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3473",
    d: "m137.033 283.379 43.717-25.4a37.551 37.551 0 0 1-11.093-10.307 47.4 47.4 0 0 1-7.173-14.2l-43.715 25.398a47.368 47.368 0 0 0 7.173 14.2 37.52 37.52 0 0 0 11.091 10.309z",
    transform: "translate(327.917 87.565)",
    style: {
      fill: "#98a4e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2620",
    style: {
      clipPath: "url(#qmiwtqla6c)"
    },
    transform: "translate(446.686 321.029)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2619",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3474",
    d: "m137.033 283.379 43.717-25.4a37.551 37.551 0 0 1-11.093-10.307 47.4 47.4 0 0 1-7.173-14.2l-43.715 25.398a47.368 47.368 0 0 0 7.173 14.2 37.52 37.52 0 0 0 11.091 10.307z",
    transform: "translate(-118.769 -233.464)",
    style: {
      fill: "#98a4e0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2624"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3476",
    d: "m166.867 212.7-43.717 25.409a9.725 9.725 0 0 0-2.367 1.939c-2.154 2.409-3.415 6.064-3.428 10.8a33.929 33.929 0 0 0 1.534 9.783l43.711-25.406a33.877 33.877 0 0 1-1.533-9.783c.013-4.735 1.273-8.39 3.427-10.8a9.735 9.735 0 0 1 2.373-1.942z",
    transform: "translate(327.797 85.803)",
    style: {
      fill: "#98a4e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2623",
    style: {
      clipPath: "url(#zvbkvqqhkd)"
    },
    transform: "translate(445.152 298.506)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2622",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3477",
    d: "m118.805 259 43.716-25.4q-.252-.84-.466-1.68l-43.716 25.406q.213.84.466 1.68z",
    transform: "translate(-117.271 -211.073)",
    style: {
      fill: "#98a4e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3478",
    d: "m118.422 258.951 43.716-25.406a32.674 32.674 0 0 1-1.066-8.1c.013-4.735 1.273-8.39 3.427-10.8a9.735 9.735 0 0 1 2.368-1.94l-43.717 25.404a9.726 9.726 0 0 0-2.367 1.939c-2.154 2.409-3.415 6.064-3.428 10.8a32.682 32.682 0 0 0 1.067 8.1z",
    transform: "translate(-117.355 -212.703)",
    style: {
      fill: "#98a4e0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2627"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3480",
    d: "M162.717 206.485 119 231.89a12.545 12.545 0 0 1 3.876-1.453c3.649-.727 7.98-.008 12.629 2.336l43.717-25.406c-4.65-2.342-8.98-3.061-12.63-2.335a12.527 12.527 0 0 0-3.875 1.453z",
    transform: "translate(327.937 85.129)",
    style: {
      fill: "#c6d5fa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2626",
    style: {
      clipPath: "url(#ydw8q9lz6e)"
    },
    transform: "translate(446.938 289.89)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2625",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3481",
    d: "m134.221 232.572 43.717-25.406-.075-.038-43.717 25.406.075.038z",
    transform: "translate(-117.716 -204.56)",
    style: {
      fill: "#c6d5fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3482",
    d: "m135.431 232.735 43.717-25.406c-4.621-2.312-8.925-3.02-12.555-2.3a12.528 12.528 0 0 0-3.876 1.453L119 231.89a12.546 12.546 0 0 1 3.876-1.453c3.63-.722 7.932-.015 12.554 2.3z",
    transform: "translate(-119.001 -204.761)",
    style: {
      fill: "#c6d5fa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2630"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3484",
    d: "m138.073 240.571 43.717-25.406a1.674 1.674 0 0 0 .749-1.149c.831-3.815 2.715-6.578 5.324-8.1l-43.717 25.4c-2.609 1.517-4.493 4.28-5.323 8.1a1.673 1.673 0 0 1-.75 1.155z",
    transform: "translate(329.555 85.228)",
    style: {
      fill: "#c6d5fa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2629",
    style: {
      clipPath: "url(#eliv80g7tf)"
    },
    transform: "translate(467.628 291.149)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2628",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3485",
    d: "m138.073 240.571 43.717-25.406a1.674 1.674 0 0 0 .749-1.149c.831-3.815 2.715-6.578 5.324-8.1l-43.717 25.4c-2.609 1.517-4.493 4.28-5.323 8.1a1.673 1.673 0 0 1-.75 1.149z",
    transform: "translate(-138.073 -205.921)",
    style: {
      fill: "#c6d5fa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2633"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3487",
    d: "m183.691 199.7-43.716 25.4a12.223 12.223 0 0 1 2.035-.944c4.393-1.573 10.018-.8 16.12 2.724a40.8 40.8 0 0 1 6.512 4.728l43.717-25.4a40.753 40.753 0 0 0-6.513-4.728c-6.1-3.522-11.726-4.3-16.12-2.724a12.3 12.3 0 0 0-2.035.944z",
    transform: "translate(329.716 84.554)",
    style: {
      fill: "#c6d5fa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2632",
    style: {
      clipPath: "url(#4l9lwz0ifg)"
    },
    transform: "translate(469.691 282.534)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2631",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3488",
    d: "m163.357 231.411 43.717-25.4a40.754 40.754 0 0 0-6.513-4.728q-.867-.5-1.721-.929l-43.717 25.406q.853.426 1.722.928a40.8 40.8 0 0 1 6.512 4.728z",
    transform: "translate(-138.69 -197.778)",
    style: {
      fill: "#c6d5fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3489",
    d: "m156.408 225.957 43.717-25.406c-5.435-2.72-10.422-3.22-14.4-1.8a12.305 12.305 0 0 0-2.035.944l-43.716 25.4a12.221 12.221 0 0 1 2.035-.944c3.976-1.423 8.964-.924 14.4 1.8z",
    transform: "translate(-139.975 -197.979)",
    style: {
      fill: "#c6d5fa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2634"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3491",
    d: "m250.336 347.7 43.716-25.4-114.73-66.24-43.716 25.405z",
    transform: "translate(329.346 89.481)",
    style: {
      fill: "#98a4e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2637"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3492",
    d: "m167.058 241.706 43.717-25.4a2.027 2.027 0 0 0 .822-1.892c0-.316-.007-.619-.007-.918.024-8.127 2.189-14.407 5.882-18.539a16.624 16.624 0 0 1 4.061-3.327l-43.717 25.4a16.67 16.67 0 0 0-4.061 3.327c-3.693 4.132-5.858 10.412-5.881 18.539 0 .3 0 .6.005.918a2.022 2.022 0 0 1-.821 1.892z",
    transform: "translate(332.014 84.015)",
    style: {
      fill: "#98a4e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2636",
    style: {
      clipPath: "url(#2ernhyibrh)"
    },
    transform: "translate(499.072 275.64)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2635",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3493",
    d: "m167.058 241.706 43.717-25.4a2.027 2.027 0 0 0 .822-1.892c0-.316-.007-.619-.007-.918.024-8.127 2.189-14.407 5.882-18.539a16.624 16.624 0 0 1 4.061-3.327l-43.717 25.4a16.67 16.67 0 0 0-4.061 3.327c-3.693 4.132-5.858 10.412-5.881 18.539 0 .3 0 .6.005.918a2.022 2.022 0 0 1-.822 1.892z",
    transform: "translate(-167.058 -191.625)",
    style: {
      fill: "#98a4e0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2640"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3495",
    d: "m261.832 344.526 43.717-25.4a15.368 15.368 0 0 1-9.267 1.862 27.675 27.675 0 0 1-11.2-3.866l-43.716 25.4a27.67 27.67 0 0 0 11.2 3.867 15.372 15.372 0 0 0 9.266-1.863z",
    transform: "translate(338.318 94.662)",
    style: {
      fill: "#98a4e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2639",
    style: {
      clipPath: "url(#ssxqx2s42i)"
    },
    transform: "translate(579.681 411.778)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2638",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3496",
    d: "m261.679 344.443 43.717-25.4a15.368 15.368 0 0 1-9.267 1.862 26.054 26.054 0 0 1-9.248-2.813l-43.717 25.4a26.08 26.08 0 0 0 9.249 2.814 15.373 15.373 0 0 0 9.266-1.863z",
    transform: "translate(-241.21 -317.034)",
    style: {
      fill: "#98a4e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3497",
    d: "m243.317 343.574 43.717-25.4q-.968-.485-1.955-1.053l-43.716 25.4q.984.57 1.954 1.053z",
    transform: "translate(-241.363 -317.116)",
    style: {
      fill: "#98a4e0"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2949"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2684"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2662"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2657"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3499",
    d: "M139.153 266.365v-.017l-.035 11.433a.779.779 0 0 0 .015.142c0 .015.008.029.011.044a.861.861 0 0 0 .031.1l.008.025c0 .007.009.014.012.022a.886.886 0 0 0 .066.121l.017.028a1.129 1.129 0 0 0 .115.141c.01.012.023.023.035.035.036.035.074.069.116.1.015.012.03.025.048.037a1.774 1.774 0 0 0 .186.124l23.579 13.7a2.569 2.569 0 0 0 .36.169c.043.016.09.027.135.041.087.028.174.059.265.079.055.013.113.02.17.029.085.015.168.033.255.042.062.007.125.007.188.01.084.005.166.012.251.012H165c.076 0 .15-.01.225-.015s.123 0 .182-.011c.085-.01.166-.028.248-.043.055-.01.113-.016.167-.029.089-.022.174-.051.258-.078.043-.015.09-.025.132-.041a2.45 2.45 0 0 0 .353-.167L190.3 278.7a1.137 1.137 0 0 0 .669-.935l.031-11.43a1.125 1.125 0 0 0-.659-.925l-23.58-13.7a3.539 3.539 0 0 0-3.207 0l-23.734 13.7a1.123 1.123 0 0 0-.667.955zm.013.123c0 .016.008.031.011.048 0-.015-.008-.029-.011-.045zm.259.483.036.036c-.012-.014-.025-.024-.036-.036zm.152.139.034.028zm-.37-.478.013.03-.013-.028zm51.7.082c.01-.018.016-.038.024-.056-.009.018-.016.042-.026.056zm.084-.248c0-.021 0-.04.005-.06-.004.019-.004.038-.007.059zm-.031.125c.007-.02.01-.038.015-.058-.008.018-.011.037-.018.057zm-.219.361c.015-.016.027-.035.041-.052-.017.016-.029.035-.044.051zm.094-.117c.012-.017.022-.036.033-.053-.014.018-.024.035-.035.052zm-.345.336.04-.031zm.136-.106c.018-.016.034-.034.051-.05-.02.015-.035.033-.054.049z",
    transform: "translate(329.643 89.081)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2656"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2655",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2645"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3500",
    d: "m139.151 265.173-.035 11.433a1.128 1.128 0 0 0 .66.922l.034-11.433a1.126 1.126 0 0 1-.659-.922z",
    transform: "translate(329.643 90.256)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2644",
    style: {
      clipPath: "url(#7bngdb1y4j)"
    },
    transform: "translate(468.759 355.429)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2643",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3501",
    d: "m139.151 265.173-.035 11.433a.829.829 0 0 0 .065.31l.035-11.433a.809.809 0 0 1-.065-.31z",
    transform: "translate(-139.116 -265.173)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3502",
    d: "m139.211 265.459-.035 11.433a1.351 1.351 0 0 0 .595.612l.034-11.433a1.348 1.348 0 0 1-.593-.612z",
    transform: "translate(-139.111 -265.149)",
    style: {
      fill: "#dae8fd"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2648"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3504",
    d: "m186.963 276.594.037-11.433a1.135 1.135 0 0 1-.669.935l-.034 11.433a1.137 1.137 0 0 0 .666-.935z",
    transform: "translate(333.646 90.255)",
    style: {
      fill: "#c6d5fa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2647",
    style: {
      clipPath: "url(#ohma5lavtk)"
    },
    transform: "translate(519.94 355.416)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2646",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3505",
    d: "m186.328 266.1-.034 11.433a1.137 1.137 0 0 0 .669-.935l.037-11.437a1.135 1.135 0 0 1-.669.935z",
    transform: "translate(-186.294 -265.161)",
    style: {
      fill: "#c6d5fa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2649"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3507",
    d: "m139.758 266.023-.034 11.433 23.58 13.7.034-11.433z",
    transform: "translate(329.694 90.328)",
    style: {
      fill: "#dae8fd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2650"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3508",
    d: "m164.45 279.726-.035 11.433 23.734-13.7.034-11.433z",
    transform: "translate(331.789 90.328)",
    style: {
      fill: "#c6d5fa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2653",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2652",
    style: {
      clipPath: "url(#od7p3asicl)"
    },
    transform: "translate(492.998 370.055)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2651",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3509",
    d: "m161.494 278.655-.035 11.432a3.277 3.277 0 0 0 1.642.385l.035-11.433a3.277 3.277 0 0 1-1.642-.384z",
    transform: "translate(-161.459 -278.655)",
    style: {
      fill: "#d4e2fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3510",
    d: "m163.008 279.039-.035 11.433a3.268 3.268 0 0 0 1.565-.385l.035-11.432a3.281 3.281 0 0 1-1.565.384z",
    transform: "translate(-161.331 -278.655)",
    style: {
      fill: "#cddcfb"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2654"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3512",
    d: "M139.817 265.413a.981.981 0 0 0-.011 1.857l23.58 13.7a3.541 3.541 0 0 0 3.208 0l23.733-13.7a.981.981 0 0 0 .011-1.857l-23.58-13.7a3.539 3.539 0 0 0-3.207 0z",
    transform: "translate(329.646 89.081)",
    style: {
      fill: "#98a4e0"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2658"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3513",
    d: "m139.947 276.442 23 13.277v-8.887l-23-13.278z",
    transform: "translate(329.714 90.458)",
    style: {
      fill: "#3c6ff7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2661"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2659"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3514",
    d: "m157.508 279.066 3.217 1.857v2.545l-3.217-1.857z",
    transform: "translate(331.203 91.435)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3515",
    d: "m147.474 275.817-6.979-4.029v-2.545l6.979 4.029z",
    transform: "translate(329.76 90.602)",
    style: {
      fill: "#15d9fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3516",
    d: "m156.964 281.3-8.616-4.974v-2.545l8.616 4.974z",
    transform: "translate(330.426 90.986)",
    style: {
      fill: "#eff6fe"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2660"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3517",
    d: "m150.2 281.056 1.754 1.013v-2.545l-1.754-1.012z",
    transform: "translate(330.584 91.388)",
    style: {
      fill: "#15d9fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3518",
    d: "m140.494 275.449 1.754 1.012v-2.545l-1.754-1.013z",
    transform: "translate(329.76 90.912)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3519",
    d: "m143.228 274.483 6.486 3.745v2.545l-6.486-3.745z",
    transform: "translate(329.992 91.046)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3520",
    d: "m152.929 280.084 8.185 4.726v2.545l-8.185-4.726z",
    transform: "translate(330.815 91.521)",
    style: {
      fill: "#eff6fe"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2682"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2677"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3521",
    d: "M139.137 254.45v-.018l-.035 11.433a.888.888 0 0 0 .015.142c0 .015.008.029.011.044a.866.866 0 0 0 .031.1l.008.024.012.023a1.029 1.029 0 0 0 .066.121l.017.028a1.224 1.224 0 0 0 .114.141l.036.035c.036.035.074.07.116.1l.048.037a1.785 1.785 0 0 0 .186.124l23.579 13.7a2.617 2.617 0 0 0 .36.169c.043.016.09.027.135.041.087.028.174.059.265.079.055.013.113.019.17.029.085.015.168.033.255.042.062.007.125.007.188.01.084.005.166.012.251.012h.02c.076 0 .15-.01.225-.015s.123 0 .183-.011c.084-.01.165-.027.247-.042.055-.011.113-.017.167-.03.089-.022.172-.05.258-.079.043-.014.09-.024.132-.04a2.574 2.574 0 0 0 .353-.166l23.734-13.7a1.133 1.133 0 0 0 .668-.935l.035-11.433a1.121 1.121 0 0 0-.659-.926l-23.58-13.7a3.532 3.532 0 0 0-3.207 0L139.8 253.5a1.123 1.123 0 0 0-.663.95zm.013.122c0 .016.008.031.011.048 0-.014-.008-.029-.011-.043zm.259.483c.011.013.024.024.036.036-.012-.014-.025-.025-.036-.036zm.152.139.034.027zm-.37-.478.013.03-.012-.028zm51.7.082c.01-.018.016-.038.024-.056-.009.017-.015.037-.026.058zm.084-.248a.581.581 0 0 0 .005-.06c-.004.019-.004.038-.007.059zm-.031.125c.007-.018.01-.038.015-.057-.008.018-.011.037-.018.056zm-.219.361a.632.632 0 0 0 .041-.052.632.632 0 0 1-.044.051zm.094-.117c.012-.017.021-.036.033-.053-.015.016-.023.034-.035.052zm-.345.336.04-.031-.042.03zm.136-.106c.018-.016.034-.034.051-.05-.02.015-.035.033-.054.049z",
    transform: "translate(329.642 88.07)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2676"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2675",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2665"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3522",
    d: "m139.135 253.257-.035 11.433a1.127 1.127 0 0 0 .66.922l.034-11.433a1.124 1.124 0 0 1-.659-.922z",
    transform: "translate(329.642 89.245)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2664",
    style: {
      clipPath: "url(#7pmtgtjbsm)"
    },
    transform: "translate(468.742 342.502)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2663",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3523",
    d: "m139.135 253.257-.035 11.433a.8.8 0 0 0 .065.309l.035-11.432a.808.808 0 0 1-.065-.31z",
    transform: "translate(-139.1 -253.257)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3524",
    d: "m139.195 253.543-.035 11.432a1.348 1.348 0 0 0 .594.613l.034-11.433a1.343 1.343 0 0 1-.593-.612z",
    transform: "translate(-139.095 -253.233)",
    style: {
      fill: "#dae8fd"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2668"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3526",
    d: "m186.946 264.678.035-11.433a1.136 1.136 0 0 1-.669.936l-.034 11.432a1.133 1.133 0 0 0 .668-.935z",
    transform: "translate(333.645 89.244)",
    style: {
      fill: "#c6d5fa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2667",
    style: {
      clipPath: "url(#6oahzd9qhn)"
    },
    transform: "translate(519.923 342.489)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2666",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3527",
    d: "m186.312 254.181-.034 11.432a1.133 1.133 0 0 0 .668-.935l.035-11.433a1.136 1.136 0 0 1-.669.936z",
    transform: "translate(-186.278 -253.245)",
    style: {
      fill: "#c6d5fa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2669"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3529",
    d: "m139.742 254.107-.034 11.433 23.58 13.7.035-11.433z",
    transform: "translate(329.693 89.317)",
    style: {
      fill: "#dae8fd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2670"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3530",
    d: "m164.434 267.811-.035 11.433 23.734-13.7.034-11.433z",
    transform: "translate(331.788 89.316)",
    style: {
      fill: "#c6d5fa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2673",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2672",
    style: {
      clipPath: "url(#n709whcu2o)"
    },
    transform: "translate(492.981 357.128)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2671",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3531",
    d: "m161.478 266.739-.035 11.433a3.278 3.278 0 0 0 1.644.384l.034-11.433a3.277 3.277 0 0 1-1.642-.384z",
    transform: "translate(-161.443 -266.739)",
    style: {
      fill: "#d4e2fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3532",
    d: "m162.992 267.123-.034 11.433a3.278 3.278 0 0 0 1.564-.384l.034-11.433a3.26 3.26 0 0 1-1.564.384z",
    transform: "translate(-161.314 -266.739)",
    style: {
      fill: "#cddcfb"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2674"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3534",
    d: "M139.8 253.5a.981.981 0 0 0-.011 1.857l23.58 13.7a3.539 3.539 0 0 0 3.207 0l23.734-13.7a.982.982 0 0 0 .011-1.858l-23.58-13.7a3.532 3.532 0 0 0-3.207 0z",
    transform: "translate(329.645 88.07)",
    style: {
      fill: "#ecf5fe"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2678"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3535",
    d: "m139.931 264.526 23 13.278v-8.887l-23-13.277z",
    transform: "translate(329.713 89.447)",
    style: {
      fill: "#3c6ff7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2681"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2679"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3536",
    d: "m157.493 267.15 3.217 1.858v2.545l-3.217-1.857z",
    transform: "translate(331.202 90.424)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3537",
    d: "m147.458 263.9-6.979-4.029v-2.545l6.979 4.029z",
    transform: "translate(329.759 89.59)",
    style: {
      fill: "#15d9fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3538",
    d: "m156.948 269.381-8.617-4.974v-2.545l8.617 4.974z",
    transform: "translate(330.425 89.975)",
    style: {
      fill: "#eff6fe"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2680"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3539",
    d: "m150.189 269.14 1.754 1.012v-2.545l-1.754-1.012z",
    transform: "translate(330.583 90.377)",
    style: {
      fill: "#15d9fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3540",
    d: "m140.478 263.533 1.754 1.013V262l-1.754-1.013z",
    transform: "translate(329.759 89.901)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3541",
    d: "m143.212 262.567 6.486 3.745v2.545l-6.486-3.745z",
    transform: "translate(329.991 90.035)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3542",
    d: "m152.913 268.168 8.186 4.726v2.545l-8.185-4.726z",
    transform: "translate(330.814 90.51)",
    style: {
      fill: "#eff6fe"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2683"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3543",
    d: "M182.48 254.259a2.014 2.014 0 0 1-.707.635l-15.1 8.718a4.852 4.852 0 0 1-4.4 0l-15.1-8.718a2.009 2.009 0 0 1-.708-.635c-.422-.639-.183-1.392.708-1.9l15.1-8.719a4.858 4.858 0 0 1 4.4 0l15.1 8.719c.891.508 1.127 1.261.707 1.9z",
    transform: "translate(330.25 88.384)",
    style: {
      fill: "#c6d5fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3544",
    d: "M182.464 254.16a2.014 2.014 0 0 1-.707.635l-15.1 8.718a4.852 4.852 0 0 1-4.4 0l-15.1-8.718a.639.639 0 1 1 0-1.27l15.1-8.722a4.858 4.858 0 0 1 4.4 0l15.1 8.722a2.006 2.006 0 0 1 .707.635z",
    transform: "translate(330.265 88.483)",
    style: {
      fill: "#15d9fd"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2765"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2704"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2699"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3545",
    d: "M167.353 282.016v-.017l-.035 11.433a.906.906 0 0 0 .015.142c0 .015.008.029.011.045a.861.861 0 0 0 .031.1l.008.024.012.023a1.031 1.031 0 0 0 .066.121l.017.028a1.328 1.328 0 0 0 .114.141l.035.035c.036.035.075.069.117.1l.048.038a1.88 1.88 0 0 0 .184.124l23.58 13.7a2.567 2.567 0 0 0 .36.169c.043.016.09.026.134.041.087.028.174.057.265.079.055.013.113.018.169.029.086.015.169.033.256.042.062.006.125.006.188.01.084.005.166.012.25.012h.021c.076 0 .15-.01.225-.015s.123 0 .183-.012c.084-.01.165-.027.247-.042.055-.01.113-.017.167-.029.089-.022.173-.051.257-.079.044-.014.09-.024.133-.04a2.37 2.37 0 0 0 .351-.167l23.735-13.7a1.135 1.135 0 0 0 .668-.935l.035-11.432a1.124 1.124 0 0 0-.658-.925l-23.58-13.7a3.539 3.539 0 0 0-3.207 0l-23.734 13.7a1.123 1.123 0 0 0-.668.957zm.013.123c0 .015.008.031.011.047 0-.015-.009-.029-.011-.044zm.259.483.036.036c-.012-.014-.025-.024-.036-.036zm.152.139.035.027zm-.37-.478.013.03-.012-.028zm51.7.082c.01-.018.016-.038.024-.056-.009.017-.016.037-.026.055zm.084-.25c0-.02 0-.039.005-.059-.004.02-.004.044-.007.059zm-.032.126c.007-.02.01-.038.015-.057-.007.016-.01.037-.017.057zm-.219.361.042-.052c-.017.017-.029.035-.044.05zm.093-.117a.556.556 0 0 0 .034-.054.556.556 0 0 1-.036.054zm-.344.336.04-.033zm.136-.107c.018-.015.034-.033.051-.049-.019.016-.034.035-.053.049z",
    transform: "translate(332.036 90.408)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2698"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2697",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2687"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3546",
    d: "m167.351 280.824-.035 11.433a1.126 1.126 0 0 0 .659.922l.035-11.433a1.126 1.126 0 0 1-.659-.922z",
    transform: "translate(332.036 91.583)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2686",
    style: {
      clipPath: "url(#2kbe27ur8p)"
    },
    transform: "translate(499.352 372.407)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2685",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3547",
    d: "m167.351 280.824-.035 11.433a.8.8 0 0 0 .065.309l.035-11.432a.789.789 0 0 1-.065-.31z",
    transform: "translate(-167.316 -280.824)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3548",
    d: "m167.411 281.11-.035 11.432a1.355 1.355 0 0 0 .593.613l.031-11.433a1.353 1.353 0 0 1-.593-.612z",
    transform: "translate(-167.311 -280.8)",
    style: {
      fill: "#dae8fd"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2690"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3550",
    d: "m215.162 292.245.035-11.433a1.134 1.134 0 0 1-.669.935l-.034 11.433a1.135 1.135 0 0 0 .668-.935z",
    transform: "translate(336.039 91.582)",
    style: {
      fill: "#c6d5fa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2689",
    style: {
      clipPath: "url(#i42czgi73q)"
    },
    transform: "translate(550.533 372.394)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2688",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3551",
    d: "m214.528 281.747-.034 11.433a1.135 1.135 0 0 0 .668-.935l.035-11.433a1.134 1.134 0 0 1-.669.935z",
    transform: "translate(-214.494 -280.812)",
    style: {
      fill: "#c6d5fa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2691"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3553",
    d: "m167.958 281.674-.034 11.433 23.58 13.7.034-11.433z",
    transform: "translate(332.088 91.655)",
    style: {
      fill: "#dae8fd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2692"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3554",
    d: "m192.65 295.377-.034 11.433 23.734-13.7.034-11.433z",
    transform: "translate(334.183 91.655)",
    style: {
      fill: "#c6d5fa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2695",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2694",
    style: {
      clipPath: "url(#s3lh594ser)"
    },
    transform: "translate(523.591 387.031)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2693",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3555",
    d: "m189.694 294.3-.035 11.434a3.3 3.3 0 0 0 1.642.384l.035-11.433a3.274 3.274 0 0 1-1.642-.385z",
    transform: "translate(-189.659 -294.305)",
    style: {
      fill: "#d4e2fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3556",
    d: "m191.208 294.69-.035 11.433a3.273 3.273 0 0 0 1.564-.384l.035-11.434a3.264 3.264 0 0 1-1.564.385z",
    transform: "translate(-189.531 -294.305)",
    style: {
      fill: "#cddcfb"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2696"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3558",
    d: "M168.017 281.064a.981.981 0 0 0-.011 1.857l23.58 13.7a3.532 3.532 0 0 0 3.207 0l23.734-13.7a.981.981 0 0 0 .011-1.857l-23.58-13.7a3.533 3.533 0 0 0-3.207 0z",
    transform: "translate(332.039 90.408)",
    style: {
      fill: "#98a4e0"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2700"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3559",
    d: "m168.147 292.093 23 13.278v-8.887l-23-13.278z",
    transform: "translate(332.106 91.785)",
    style: {
      fill: "#3c6ff7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2703"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2701"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3560",
    d: "m185.708 294.717 3.217 1.857v2.545l-3.217-1.857z",
    transform: "translate(333.596 92.761)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3561",
    d: "m175.673 291.468-6.979-4.03v-2.545l6.979 4.03z",
    transform: "translate(332.153 91.928)",
    style: {
      fill: "#15d9fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3562",
    d: "m185.164 296.948-8.617-4.974v-2.545l8.617 4.975z",
    transform: "translate(332.819 92.312)",
    style: {
      fill: "#eff6fe"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2702"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3563",
    d: "m178.4 296.707 1.754 1.013v-2.545l-1.754-1.012z",
    transform: "translate(332.977 92.714)",
    style: {
      fill: "#15d9fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3564",
    d: "m168.694 291.1 1.754 1.012v-2.545l-1.754-1.012z",
    transform: "translate(332.153 92.238)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3565",
    d: "m171.428 290.134 6.486 3.744v2.545l-6.486-3.744z",
    transform: "translate(332.385 92.372)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3566",
    d: "m181.129 295.735 8.185 4.725V303l-8.185-4.725z",
    transform: "translate(333.208 92.847)",
    style: {
      fill: "#eff6fe"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2724"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2719"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3567",
    d: "M167.369 270.1v-.017l-.035 11.433a.781.781 0 0 0 .015.142c0 .015.008.029.011.044a.861.861 0 0 0 .031.1l.008.025.012.022a1.016 1.016 0 0 0 .066.122l.016.028a1.233 1.233 0 0 0 .115.141l.035.035c.037.035.075.069.117.1l.047.037a2.058 2.058 0 0 0 .185.124l23.58 13.7a2.5 2.5 0 0 0 .36.17c.042.016.09.026.135.041.087.028.172.058.264.079.056.013.114.02.17.029.086.015.169.033.256.042.062.007.125.007.188.01.084.005.166.012.25.012h.021c.076 0 .15-.01.225-.015s.123 0 .182-.011c.085-.011.166-.027.248-.043.055-.01.113-.016.167-.029.089-.022.173-.051.258-.079.043-.014.09-.024.132-.04a2.506 2.506 0 0 0 .353-.167l23.734-13.7a1.135 1.135 0 0 0 .668-.935l.035-11.433a1.126 1.126 0 0 0-.659-.925l-23.58-13.7a3.539 3.539 0 0 0-3.207 0l-23.734 13.7a1.121 1.121 0 0 0-.669.958zm.012.123c0 .016.009.032.012.048 0-.014-.009-.029-.011-.044zm.26.483.037.036-.037-.036zm.152.139.035.027zm-.37-.478.012.03-.012-.028zm51.7.082c.01-.018.016-.038.024-.056-.01.018-.016.037-.026.056zm.083-.25c0-.02 0-.039.005-.059-.003.02-.003.039-.011.06zm-.031.126c.006-.018.01-.038.015-.057-.007.018-.01.038-.017.057zm-.22.361a.632.632 0 0 0 .042-.052.632.632 0 0 1-.044.052zm.094-.117c.013-.017.022-.036.033-.053-.013.017-.022.036-.035.053zm-.344.336c.014-.01.026-.022.04-.033-.015.012-.027.028-.045.033zm.136-.106c.018-.016.034-.034.051-.05-.019.016-.034.034-.053.051z",
    transform: "translate(332.037 89.397)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2718"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2717",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2707"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3568",
    d: "m167.367 268.908-.035 11.433a1.126 1.126 0 0 0 .658.922l.035-11.433a1.126 1.126 0 0 1-.658-.922z",
    transform: "translate(332.037 90.572)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2706",
    style: {
      clipPath: "url(#1rcq2bpz5s)"
    },
    transform: "translate(499.369 359.48)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2705",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3569",
    d: "m167.367 268.908-.035 11.433a.789.789 0 0 0 .065.31l.035-11.434a.779.779 0 0 1-.065-.309z",
    transform: "translate(-167.332 -268.908)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3570",
    d: "m167.427 269.193-.035 11.434a1.353 1.353 0 0 0 .593.612l.035-11.433a1.34 1.34 0 0 1-.593-.613z",
    transform: "translate(-167.327 -268.884)",
    style: {
      fill: "#dae8fd"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2710"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3572",
    d: "m215.178 280.329.035-11.433a1.134 1.134 0 0 1-.669.935l-.034 11.433a1.135 1.135 0 0 0 .668-.935z",
    transform: "translate(336.04 90.571)",
    style: {
      fill: "#c6d5fa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2709",
    style: {
      clipPath: "url(#3sgvn6vl3t)"
    },
    transform: "translate(550.55 359.467)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2708",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3573",
    d: "m214.544 269.831-.034 11.433a1.135 1.135 0 0 0 .668-.935l.035-11.433a1.134 1.134 0 0 1-.669.935z",
    transform: "translate(-214.51 -268.896)",
    style: {
      fill: "#c6d5fa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2711"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3575",
    d: "m167.974 269.758-.034 11.433 23.58 13.7.034-11.433z",
    transform: "translate(332.089 90.644)",
    style: {
      fill: "#dae8fd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2712"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3576",
    d: "m192.666 283.461-.034 11.433 23.734-13.7.034-11.433z",
    transform: "translate(334.183 90.645)",
    style: {
      fill: "#c6d5fa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2715",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2714",
    style: {
      clipPath: "url(#scei4kdocu)"
    },
    transform: "translate(523.608 374.106)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2713",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3577",
    d: "m189.71 282.39-.035 11.432a3.274 3.274 0 0 0 1.642.385l.035-11.433a3.271 3.271 0 0 1-1.642-.384z",
    transform: "translate(-189.675 -282.39)",
    style: {
      fill: "#d4e2fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3578",
    d: "m191.224 282.774-.035 11.433a3.269 3.269 0 0 0 1.565-.385l.034-11.432a3.273 3.273 0 0 1-1.564.384z",
    transform: "translate(-189.547 -282.39)",
    style: {
      fill: "#cddcfb"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2716"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3580",
    d: "M168.033 269.148a.981.981 0 0 0-.011 1.857l23.58 13.7a3.539 3.539 0 0 0 3.207 0l23.734-13.7a.981.981 0 0 0 .011-1.857l-23.58-13.7a3.539 3.539 0 0 0-3.207 0z",
    transform: "translate(332.04 89.397)",
    style: {
      fill: "#98a4e0"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2720"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3581",
    d: "m168.163 280.178 23 13.277v-8.887l-23-13.277z",
    transform: "translate(332.108 90.774)",
    style: {
      fill: "#3c6ff7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2723"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2721"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3582",
    d: "m185.725 282.8 3.217 1.858v2.542l-3.217-1.857z",
    transform: "translate(333.597 91.751)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3583",
    d: "m175.69 279.553-6.979-4.03v-2.545l6.979 4.03z",
    transform: "translate(332.154 90.918)",
    style: {
      fill: "#15d9fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3584",
    d: "m185.18 285.032-8.616-4.975v-2.545l8.616 4.975z",
    transform: "translate(332.82 91.302)",
    style: {
      fill: "#eff6fe"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2722"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3585",
    d: "m178.421 284.791 1.754 1.012v-2.545l-1.754-1.012z",
    transform: "translate(332.978 91.704)",
    style: {
      fill: "#15d9fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3586",
    d: "m168.71 279.185 1.754 1.012v-2.545l-1.754-1.013z",
    transform: "translate(332.154 91.228)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3587",
    d: "m171.444 278.218 6.486 3.744v2.545l-6.486-3.744z",
    transform: "translate(332.386 91.362)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3588",
    d: "m181.145 283.819 8.185 4.725v2.545l-8.185-4.725z",
    transform: "translate(333.209 91.837)",
    style: {
      fill: "#eff6fe"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2744"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2739"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3589",
    d: "M167.353 258.184v-.017l-.035 11.433a.892.892 0 0 0 .015.142c0 .015.008.029.011.044a.862.862 0 0 0 .031.1l.008.025.012.022a1.03 1.03 0 0 0 .066.122l.017.028a1.229 1.229 0 0 0 .114.141l.035.035a1.372 1.372 0 0 0 .117.1c.015.012.03.025.048.037a1.88 1.88 0 0 0 .184.124l23.58 13.7a2.443 2.443 0 0 0 .36.169c.043.016.09.027.134.041.087.028.174.058.265.079.055.013.113.02.169.029.086.015.169.033.256.042.062.006.125.006.188.01.084.005.166.012.25.012h.021c.076 0 .15-.01.225-.014s.123-.005.183-.012c.084-.011.165-.027.247-.043.055-.01.113-.016.167-.029.089-.022.173-.05.257-.078.044-.015.09-.025.133-.041a2.379 2.379 0 0 0 .351-.167l23.735-13.7a1.134 1.134 0 0 0 .668-.935l.035-11.433a1.126 1.126 0 0 0-.658-.925l-23.58-13.7a3.533 3.533 0 0 0-3.207 0l-23.734 13.7a1.123 1.123 0 0 0-.668.959zm.013.123c0 .016.008.031.011.047 0-.014-.009-.029-.011-.043zm.259.483a.577.577 0 0 0 0 0zm.152.139.035.028zm-.37-.478.013.03-.012-.028zm51.7.082c.01-.018.016-.038.024-.056-.009.018-.016.037-.026.055zm.084-.248c0-.02 0-.04.005-.06-.004.019-.004.04-.007.059zm-.032.125c.007-.02.01-.038.015-.058-.007.019-.01.037-.017.057zm-.219.361c.015-.016.027-.035.042-.052-.017.016-.029.035-.044.051zm.093-.117c.013-.017.023-.036.034-.053-.013.016-.023.035-.036.052zm-.344.336c.014-.01.026-.022.04-.031-.015.008-.029.02-.041.03zm.136-.106c.018-.016.034-.034.051-.05-.019.015-.034.033-.053.049z",
    transform: "translate(332.036 88.386)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2738"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2737",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2727"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3590",
    d: "m167.351 256.992-.035 11.433a1.126 1.126 0 0 0 .659.922l.035-11.433a1.126 1.126 0 0 1-.659-.922z",
    transform: "translate(332.036 89.561)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2726",
    style: {
      clipPath: "url(#nmkn7c6cpv)"
    },
    transform: "translate(499.352 346.553)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2725",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3591",
    d: "m167.351 256.992-.035 11.433a.808.808 0 0 0 .065.31l.035-11.433a.788.788 0 0 1-.065-.31z",
    transform: "translate(-167.316 -256.992)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3592",
    d: "m167.411 257.278-.035 11.433a1.354 1.354 0 0 0 .593.612L168 257.89a1.343 1.343 0 0 1-.593-.612z",
    transform: "translate(-167.311 -256.968)",
    style: {
      fill: "#dae8fd"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2730"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3594",
    d: "m215.162 268.413.035-11.433a1.133 1.133 0 0 1-.669.935l-.034 11.433a1.134 1.134 0 0 0 .668-.935z",
    transform: "translate(336.039 89.56)",
    style: {
      fill: "#c6d5fa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2729",
    style: {
      clipPath: "url(#3b17vy35ew)"
    },
    transform: "translate(550.533 346.54)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2728",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3595",
    d: "m214.528 257.915-.034 11.433a1.134 1.134 0 0 0 .668-.935l.035-11.433a1.133 1.133 0 0 1-.669.935z",
    transform: "translate(-214.494 -256.98)",
    style: {
      fill: "#c6d5fa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2731"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3597",
    d: "m167.958 257.842-.034 11.433 23.58 13.7.034-11.433z",
    transform: "translate(332.088 89.633)",
    style: {
      fill: "#dae8fd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2732"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3598",
    d: "m192.65 271.545-.034 11.433 23.734-13.7.034-11.433z",
    transform: "translate(334.183 89.633)",
    style: {
      fill: "#c6d5fa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2735",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2734",
    style: {
      clipPath: "url(#0hcfp9piqx)"
    },
    transform: "translate(523.591 361.178)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2733",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3599",
    d: "m189.694 270.474-.035 11.433a3.277 3.277 0 0 0 1.642.384l.035-11.433a3.274 3.274 0 0 1-1.642-.384z",
    transform: "translate(-189.659 -270.474)",
    style: {
      fill: "#d4e2fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3600",
    d: "m191.208 270.858-.035 11.433a3.273 3.273 0 0 0 1.564-.384l.035-11.433a3.265 3.265 0 0 1-1.564.384z",
    transform: "translate(-189.531 -270.474)",
    style: {
      fill: "#cddcfb"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2736"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3602",
    d: "M168.017 257.232a.981.981 0 0 0-.011 1.857l23.58 13.7a3.539 3.539 0 0 0 3.207 0l23.734-13.7a.981.981 0 0 0 .011-1.857l-23.58-13.7a3.533 3.533 0 0 0-3.207 0z",
    transform: "translate(332.039 88.386)",
    style: {
      fill: "#98a4e0"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2740"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3603",
    d: "m168.147 268.261 23 13.278v-8.887l-23-13.278z",
    transform: "translate(332.106 89.763)",
    style: {
      fill: "#3c6ff7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2743"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2741"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3604",
    d: "m185.708 270.885 3.217 1.857v2.545l-3.217-1.857z",
    transform: "translate(333.596 90.739)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3605",
    d: "m175.673 267.637-6.979-4.029v-2.545l6.979 4.03z",
    transform: "translate(332.153 89.906)",
    style: {
      fill: "#15d9fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3606",
    d: "m185.164 273.116-8.617-4.975V265.6l8.617 4.975z",
    transform: "translate(332.819 90.29)",
    style: {
      fill: "#eff6fe"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2742"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3607",
    d: "m178.4 272.875 1.754 1.013v-2.545l-1.754-1.013z",
    transform: "translate(332.977 90.692)",
    style: {
      fill: "#15d9fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3608",
    d: "m168.694 267.269 1.754 1.012v-2.545l-1.754-1.012z",
    transform: "translate(332.153 90.216)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3609",
    d: "m171.428 266.3 6.486 3.744v2.545l-6.486-3.745z",
    transform: "translate(332.385 90.35)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3610",
    d: "m181.129 271.9 8.185 4.725v2.545l-8.185-4.726z",
    transform: "translate(333.208 90.825)",
    style: {
      fill: "#eff6fe"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2764"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2759"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3611",
    d: "M167.369 246.207v-.017l-.035 11.432a.792.792 0 0 0 .015.143c0 .015.008.029.011.043a.8.8 0 0 0 .031.1l.008.025a.221.221 0 0 0 .012.022 1.029 1.029 0 0 0 .066.123l.016.027a1.245 1.245 0 0 0 .115.142l.035.034a1.562 1.562 0 0 0 .117.1l.047.038a2.052 2.052 0 0 0 .185.124l23.58 13.7a2.393 2.393 0 0 0 .36.169c.042.017.09.027.135.041.087.029.172.059.264.08.056.012.114.018.17.029.086.015.169.033.256.041.062.007.125.007.188.011.084 0 .166.012.25.012h.021c.076 0 .15-.009.225-.014s.123 0 .182-.012c.085-.01.166-.027.248-.042.055-.011.113-.017.167-.03.089-.021.173-.05.258-.078.043-.014.09-.025.132-.041a2.508 2.508 0 0 0 .353-.166l23.734-13.7a1.135 1.135 0 0 0 .668-.935l.035-11.433a1.124 1.124 0 0 0-.659-.925l-23.58-13.7a3.539 3.539 0 0 0-3.207 0l-23.734 13.7a1.122 1.122 0 0 0-.669.957zm.012.123c0 .015.009.031.012.047 0-.015-.009-.029-.011-.044zm.26.483.037.036-.037-.036zm.152.138.035.027zm-.37-.477.012.03-.012-.029zm51.7.082c.01-.02.016-.038.024-.056-.01.018-.016.036-.026.055zm.083-.25c0-.02 0-.039.005-.06-.003.021-.003.04-.011.06zm-.031.126.015-.058c-.007.019-.01.038-.017.058zm-.22.361c.016-.017.028-.035.042-.052-.016.017-.028.035-.044.052zm.094-.117a.561.561 0 0 0 .033-.054.561.561 0 0 1-.035.054zm-.344.336.04-.033zm.136-.107.051-.049c-.019.016-.034.033-.053.044z",
    transform: "translate(332.037 87.37)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2758"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2757",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2747"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3612",
    d: "m167.367 245.015-.035 11.432a1.127 1.127 0 0 0 .658.923l.035-11.433a1.126 1.126 0 0 1-.658-.922z",
    transform: "translate(332.037 88.545)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2746",
    style: {
      clipPath: "url(#mzzjmw5uey)"
    },
    transform: "translate(499.369 333.56)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2745",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3613",
    d: "m167.367 245.015-.035 11.432a.785.785 0 0 0 .065.31l.035-11.433a.783.783 0 0 1-.065-.309z",
    transform: "translate(-167.332 -245.015)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3614",
    d: "m167.427 245.3-.035 11.433a1.35 1.35 0 0 0 .593.613l.035-11.433a1.35 1.35 0 0 1-.593-.613z",
    transform: "translate(-167.327 -244.991)",
    style: {
      fill: "#dae8fd"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2750"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3616",
    d: "m215.178 256.436.035-11.436a1.135 1.135 0 0 1-.669.935l-.034 11.433a1.135 1.135 0 0 0 .668-.932z",
    transform: "translate(336.04 88.544)",
    style: {
      fill: "#c6d5fa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2749",
    style: {
      clipPath: "url(#7oq7f2dx5z)"
    },
    transform: "translate(550.55 333.547)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2748",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3617",
    d: "m214.544 245.938-.034 11.433a1.135 1.135 0 0 0 .668-.935l.035-11.436a1.135 1.135 0 0 1-.669.935z",
    transform: "translate(-214.51 -245.003)",
    style: {
      fill: "#c6d5fa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2751"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3619",
    d: "m167.974 245.865-.034 11.433 23.58 13.7.034-11.433z",
    transform: "translate(332.089 88.617)",
    style: {
      fill: "#dae8fd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2752"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3620",
    d: "M192.666 259.568 192.632 271l23.734-13.7.034-11.433z",
    transform: "translate(334.183 88.617)",
    style: {
      fill: "#c6d5fa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2755",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2754",
    style: {
      clipPath: "url(#e3fkbed99A)"
    },
    transform: "translate(523.608 348.185)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2753",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3621",
    d: "m189.71 258.5-.035 11.433a3.274 3.274 0 0 0 1.642.384l.035-11.432a3.283 3.283 0 0 1-1.642-.385z",
    transform: "translate(-189.675 -258.496)",
    style: {
      fill: "#d4e2fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3622",
    d: "m191.224 258.881-.035 11.432a3.256 3.256 0 0 0 1.565-.384l.034-11.433a3.261 3.261 0 0 1-1.564.385z",
    transform: "translate(-189.547 -258.496)",
    style: {
      fill: "#cddcfb"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2756"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3624",
    d: "M168.033 245.254a.982.982 0 0 0-.011 1.858l23.58 13.7a3.532 3.532 0 0 0 3.207 0l23.734-13.7a.981.981 0 0 0 .011-1.857l-23.58-13.7a3.539 3.539 0 0 0-3.207 0z",
    transform: "translate(332.04 87.37)",
    style: {
      fill: "#ecf5fe"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2760"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3625",
    d: "m168.163 256.284 23 13.277v-8.887l-23-13.277z",
    transform: "translate(332.108 88.747)",
    style: {
      fill: "#3c6ff7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2763"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2761"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3626",
    d: "m185.725 258.908 3.217 1.857v2.545l-3.217-1.857z",
    transform: "translate(333.597 89.723)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3627",
    d: "m175.69 255.659-6.979-4.03v-2.545l6.979 4.03z",
    transform: "translate(332.154 88.89)",
    style: {
      fill: "#15d9fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3628",
    d: "m185.18 261.138-8.616-4.974v-2.545l8.616 4.974z",
    transform: "translate(332.82 89.275)",
    style: {
      fill: "#eff6fe"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2762"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3629",
    d: "m178.421 260.9 1.754 1.013v-2.545l-1.754-1.012z",
    transform: "translate(332.978 89.676)",
    style: {
      fill: "#15d9fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3630",
    d: "m168.71 255.291 1.754 1.012v-2.545l-1.754-1.013z",
    transform: "translate(332.154 89.201)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3631",
    d: "m171.444 254.325 6.486 3.744v2.545l-6.486-3.744z",
    transform: "translate(332.386 89.335)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3632",
    d: "m181.145 259.925 8.185 4.725v2.55l-8.185-4.726z",
    transform: "translate(333.209 89.81)",
    style: {
      fill: "#eff6fe"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3633",
    d: "M210.7 246.46a2.014 2.014 0 0 1-.707.635l-15.1 8.719a4.858 4.858 0 0 1-4.4 0l-15.1-8.719a2.009 2.009 0 0 1-.708-.635c-.422-.639-.183-1.391.708-1.9l15.1-8.718a4.858 4.858 0 0 1 4.4 0l15.1 8.718c.887.509 1.125 1.261.707 1.9z",
    transform: "translate(332.643 87.722)",
    style: {
      fill: "#c6d5fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3634",
    d: "M210.68 246.361a2.014 2.014 0 0 1-.707.635l-15.1 8.719a4.858 4.858 0 0 1-4.4 0L175.369 247a.638.638 0 1 1 0-1.269l15.1-8.722a4.851 4.851 0 0 1 4.4 0l15.1 8.722a2.014 2.014 0 0 1 .711.63z",
    transform: "translate(332.659 87.821)",
    style: {
      fill: "#15d9fd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2866"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2785"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2780"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3635",
    d: "M193.8 297.081v-.017l-.035 11.432a.79.79 0 0 0 .015.143c0 .015.008.029.011.044a.861.861 0 0 0 .031.1l.008.024.012.022a.907.907 0 0 0 .066.123l.016.028a1.343 1.343 0 0 0 .115.141l.036.035c.036.035.074.069.116.1l.047.038a1.927 1.927 0 0 0 .187.124l23.579 13.7a2.446 2.446 0 0 0 .36.17c.042.016.09.026.135.041.087.028.174.057.265.079.055.013.113.018.169.029.086.015.169.033.256.041.062.008.125.008.188.011.084.005.166.012.251.012h.02c.076 0 .15-.01.225-.015s.123 0 .182-.012c.085-.01.166-.027.248-.042.055-.01.113-.017.167-.03.089-.021.174-.05.258-.078.043-.014.09-.024.131-.041a2.346 2.346 0 0 0 .354-.166l23.733-13.7a1.138 1.138 0 0 0 .67-.935l.034-11.433a1.124 1.124 0 0 0-.659-.925l-23.58-13.7a3.539 3.539 0 0 0-3.207 0l-23.734 13.7a1.121 1.121 0 0 0-.67.957zm.013.123c0 .015.008.031.011.047 0-.015-.008-.029-.011-.044zm.259.483.037.036c-.009-.014-.022-.023-.033-.036zm.152.138.035.027zm-.37-.477.013.03-.013-.029zm51.7.082a.606.606 0 0 0 .024-.056.606.606 0 0 1-.022.055zm.084-.25c0-.02 0-.039.005-.059 0 .02 0 .039-.003.059zm-.031.126c.007-.02.01-.039.015-.057-.004.018-.007.037-.014.057zm-.219.361c.015-.017.027-.035.041-.052-.013.017-.029.035-.04.052zm.093-.117c.013-.017.022-.036.034-.054-.015.018-.015.037-.033.054zm-.344.336.04-.033zm.136-.107c.018-.015.034-.033.051-.049-.016.016-.031.034-.05.049z",
    transform: "translate(334.28 91.687)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2779"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2778",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2768"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3636",
    d: "m193.8 295.889-.035 11.432a1.125 1.125 0 0 0 .66.923l.034-11.433a1.126 1.126 0 0 1-.659-.922z",
    transform: "translate(334.28 92.862)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2767",
    style: {
      clipPath: "url(#zw43usr7jB)"
    },
    transform: "translate(528.047 388.751)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2766",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3637",
    d: "m193.8 295.889-.035 11.432a.82.82 0 0 0 .065.31l.035-11.432a.788.788 0 0 1-.065-.31z",
    transform: "translate(-193.767 -295.889)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3638",
    d: "m193.862 296.175-.035 11.432a1.347 1.347 0 0 0 .594.613l.034-11.433a1.353 1.353 0 0 1-.593-.612z",
    transform: "translate(-193.762 -295.865)",
    style: {
      fill: "#dae8fd"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2771"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3640",
    d: "m241.613 307.31.035-11.433a1.134 1.134 0 0 1-.669.935l-.035 11.433a1.132 1.132 0 0 0 .669-.935z",
    transform: "translate(338.283 92.861)",
    style: {
      fill: "#c6d5fa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2770",
    style: {
      clipPath: "url(#sjruse0tsC)"
    },
    transform: "translate(579.227 388.738)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2769",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3641",
    d: "m240.979 296.812-.035 11.433a1.132 1.132 0 0 0 .669-.935l.035-11.433a1.134 1.134 0 0 1-.669.935z",
    transform: "translate(-240.944 -295.877)",
    style: {
      fill: "#c6d5fa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2772"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3643",
    d: "m194.409 296.739-.034 11.433 23.58 13.7.034-11.433z",
    transform: "translate(334.331 92.934)",
    style: {
      fill: "#dae8fd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2773"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3644",
    d: "m219.1 310.442-.034 11.433 23.734-13.7.034-11.433z",
    transform: "translate(336.426 92.934)",
    style: {
      fill: "#c6d5fa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2776",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2775",
    style: {
      clipPath: "url(#e49xmgwhpD)"
    },
    transform: "translate(552.286 403.376)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2774",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3645",
    d: "m216.145 309.37-.035 11.43a3.288 3.288 0 0 0 1.642.385l.035-11.433a3.282 3.282 0 0 1-1.642-.385z",
    transform: "translate(-216.11 -309.37)",
    style: {
      fill: "#d4e2fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3646",
    d: "m217.659 309.755-.035 11.433a3.268 3.268 0 0 0 1.565-.385l.034-11.433a3.264 3.264 0 0 1-1.564.385z",
    transform: "translate(-215.982 -309.37)",
    style: {
      fill: "#cddcfb"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2777"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3648",
    d: "M194.468 296.128a.982.982 0 0 0-.011 1.858l23.58 13.7a3.533 3.533 0 0 0 3.207 0l23.734-13.7a.981.981 0 0 0 .011-1.857l-23.58-13.7a3.539 3.539 0 0 0-3.207 0z",
    transform: "translate(334.283 91.687)",
    style: {
      fill: "#98a4e0"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2781"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3649",
    d: "m194.6 307.158 23 13.277v-8.887l-23-13.278z",
    transform: "translate(334.351 93.064)",
    style: {
      fill: "#3c6ff7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2784"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2782"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3650",
    d: "m212.159 309.782 3.217 1.857v2.545l-3.217-1.857z",
    transform: "translate(335.84 94.04)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3651",
    d: "m202.125 306.533-6.979-4.03v-2.545l6.979 4.03z",
    transform: "translate(334.397 93.207)",
    style: {
      fill: "#15d9fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3652",
    d: "M211.615 312.013 203 307.038v-2.545l8.616 4.975z",
    transform: "translate(335.063 93.592)",
    style: {
      fill: "#eff6fe"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2783"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3653",
    d: "m204.856 311.772 1.754 1.013v-2.545l-1.754-1.012z",
    transform: "translate(335.221 93.993)",
    style: {
      fill: "#15d9fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3654",
    d: "m195.145 306.165 1.754 1.012v-2.545l-1.754-1.013z",
    transform: "translate(334.397 93.518)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3655",
    d: "m197.879 305.2 6.486 3.744v2.545l-6.486-3.744z",
    transform: "translate(334.629 93.651)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3656",
    d: "m207.58 310.8 8.185 4.725v2.545l-8.185-4.726z",
    transform: "translate(335.452 94.127)",
    style: {
      fill: "#eff6fe"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2805"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2800"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3657",
    d: "M193.8 285.165v-.017l-.035 11.433a.779.779 0 0 0 .015.142c0 .015.008.029.011.044a.936.936 0 0 0 .031.1l.008.024c0 .008.009.015.012.022a.843.843 0 0 0 .066.123.2.2 0 0 1 .016.028 1.231 1.231 0 0 0 .115.141l.036.035c.036.035.074.069.116.1.015.013.03.026.047.038a1.927 1.927 0 0 0 .187.124l23.579 13.7a2.437 2.437 0 0 0 .36.17c.042.016.09.026.135.041.087.028.174.057.265.079.055.013.113.018.169.029.086.015.169.033.256.041.062.008.125.008.188.011.084.005.166.012.251.012h.02c.076 0 .15-.01.225-.015s.123 0 .182-.012c.085-.01.166-.027.248-.042.055-.01.113-.016.167-.029.089-.022.174-.051.258-.079.043-.014.09-.024.131-.04a2.459 2.459 0 0 0 .354-.167l23.733-13.7a1.138 1.138 0 0 0 .67-.935l.034-11.432a1.126 1.126 0 0 0-.659-.925l-23.58-13.7a3.539 3.539 0 0 0-3.207 0l-23.734 13.7a1.121 1.121 0 0 0-.67.956zm.013.123c0 .016.008.032.011.048 0-.014-.008-.029-.011-.044zm.259.483.037.036zm.152.139.035.027zm-.37-.478.013.03-.013-.028zm51.7.082c.01-.018.016-.038.024-.056a.274.274 0 0 1-.022.055zm.084-.25c0-.02 0-.039.005-.059 0 .02 0 .039-.003.059zm-.031.126c.007-.018.01-.038.015-.057-.004.018-.007.038-.014.057zm-.219.361c.015-.016.027-.035.041-.052-.013.017-.029.036-.04.052zm.093-.117c.013-.017.022-.036.034-.053-.015.019-.015.036-.033.053zm-.344.336.04-.033zm.136-.106c.018-.016.034-.034.051-.05-.016.016-.031.034-.05.05z",
    transform: "translate(334.28 90.676)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2799"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2798",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2788"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3658",
    d: "m193.8 283.973-.035 11.433a1.125 1.125 0 0 0 .66.922l.034-11.433a1.126 1.126 0 0 1-.659-.922z",
    transform: "translate(334.28 91.851)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2787",
    style: {
      clipPath: "url(#60j8ma5acE)"
    },
    transform: "translate(528.047 375.824)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2786",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3659",
    d: "m193.8 283.973-.035 11.433a.818.818 0 0 0 .065.309l.035-11.433a.779.779 0 0 1-.065-.309z",
    transform: "translate(-193.767 -283.973)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3660",
    d: "m193.862 284.258-.035 11.433a1.347 1.347 0 0 0 .594.613l.034-11.433a1.345 1.345 0 0 1-.593-.613z",
    transform: "translate(-193.762 -283.949)",
    style: {
      fill: "#dae8fd"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2791"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3662",
    d: "m241.613 295.394.035-11.433a1.134 1.134 0 0 1-.669.935l-.035 11.433a1.132 1.132 0 0 0 .669-.935z",
    transform: "translate(338.283 91.85)",
    style: {
      fill: "#c6d5fa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2790",
    style: {
      clipPath: "url(#utt9yna62F)"
    },
    transform: "translate(579.227 375.811)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2789",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3663",
    d: "m240.979 284.9-.035 11.433a1.132 1.132 0 0 0 .669-.935l.035-11.433a1.134 1.134 0 0 1-.669.935z",
    transform: "translate(-240.944 -283.961)",
    style: {
      fill: "#c6d5fa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2792"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3665",
    d: "m194.409 284.823-.034 11.433 23.58 13.7.034-11.433z",
    transform: "translate(334.331 91.923)",
    style: {
      fill: "#dae8fd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2793"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3666",
    d: "m219.1 298.526-.034 11.433 23.734-13.7.034-11.433z",
    transform: "translate(336.426 91.923)",
    style: {
      fill: "#c6d5fa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2796",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2795",
    style: {
      clipPath: "url(#xpx7g57cnG)"
    },
    transform: "translate(552.286 390.45)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2794",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3667",
    d: "m216.145 297.455-.035 11.432a3.288 3.288 0 0 0 1.642.385l.035-11.433a3.293 3.293 0 0 1-1.642-.384z",
    transform: "translate(-216.11 -297.455)",
    style: {
      fill: "#d4e2fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3668",
    d: "m217.659 297.839-.035 11.433a3.269 3.269 0 0 0 1.565-.385l.034-11.432a3.276 3.276 0 0 1-1.564.384z",
    transform: "translate(-215.982 -297.455)",
    style: {
      fill: "#cddcfb"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2797"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3670",
    d: "M194.468 284.213a.981.981 0 0 0-.011 1.857l23.58 13.7a3.539 3.539 0 0 0 3.207 0l23.734-13.7a.981.981 0 0 0 .011-1.857l-23.58-13.7a3.539 3.539 0 0 0-3.207 0z",
    transform: "translate(334.283 90.676)",
    style: {
      fill: "#98a4e0"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2801"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3671",
    d: "m194.6 295.242 23 13.278v-8.887l-23-13.277z",
    transform: "translate(334.351 92.053)",
    style: {
      fill: "#3c6ff7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2804"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2802"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3672",
    d: "m212.159 297.866 3.217 1.858v2.545l-3.217-1.857z",
    transform: "translate(335.84 93.03)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3673",
    d: "m202.125 294.618-6.979-4.03v-2.545l6.979 4.03z",
    transform: "translate(334.397 92.197)",
    style: {
      fill: "#15d9fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3674",
    d: "M211.615 300.1 203 295.122v-2.545l8.616 4.975z",
    transform: "translate(335.063 92.581)",
    style: {
      fill: "#eff6fe"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2803"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3675",
    d: "m204.856 299.856 1.754 1.013v-2.545l-1.754-1.013z",
    transform: "translate(335.221 92.983)",
    style: {
      fill: "#15d9fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3676",
    d: "m195.145 294.249 1.754 1.013v-2.545l-1.754-1.012z",
    transform: "translate(334.397 92.507)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3677",
    d: "m197.879 293.283 6.486 3.744v2.545l-6.486-3.744z",
    transform: "translate(334.629 92.641)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3678",
    d: "m207.58 298.884 8.185 4.726v2.545l-8.185-4.725z",
    transform: "translate(335.452 93.116)",
    style: {
      fill: "#eff6fe"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2825"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2820"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3679",
    d: "M193.82 273.249v-.017l-.035 11.433a.78.78 0 0 0 .015.142c0 .015.008.029.011.044a.881.881 0 0 0 .031.1l.008.025.012.022a1.027 1.027 0 0 0 .066.121l.017.028a1.223 1.223 0 0 0 .114.141l.035.035a1.368 1.368 0 0 0 .117.1.571.571 0 0 0 .048.038 1.9 1.9 0 0 0 .184.124l23.58 13.7a2.556 2.556 0 0 0 .36.169c.043.016.09.027.135.041.087.028.172.058.265.079.055.013.113.018.169.029.086.015.169.033.256.042.062.007.125.007.188.01.084.005.166.012.25.012h.021c.075 0 .15-.01.225-.014s.123-.005.182-.013c.085-.01.166-.027.248-.042.055-.01.113-.016.167-.029.089-.022.173-.051.257-.078.044-.015.09-.025.133-.041a2.435 2.435 0 0 0 .352-.167l23.734-13.7a1.133 1.133 0 0 0 .669-.935l.035-11.432a1.124 1.124 0 0 0-.659-.925l-23.58-13.7a3.539 3.539 0 0 0-3.207 0l-23.734 13.7a1.123 1.123 0 0 0-.669.958zm.012.123c0 .016.008.031.012.047 0-.014-.009-.029-.011-.043zm.26.483.037.036c-.013-.014-.029-.024-.037-.036zm.152.139.035.028zm-.37-.478.012.03-.012-.028zm51.7.082c.01-.018.016-.038.024-.056l-.026.058zm.084-.248c0-.02 0-.04.005-.06-.004.019-.004.04-.007.059zm-.031.125c.007-.02.01-.038.015-.057-.008.018-.011.036-.018.056zm-.219.361c.015-.016.027-.035.041-.052-.017.016-.029.035-.044.051zm.093-.117c.013-.017.022-.036.033-.053-.014.016-.023.034-.034.052zm-.344.336c.014-.011.026-.022.04-.031-.016.009-.028.019-.042.03zm.136-.106c.018-.016.034-.034.051-.05-.02.015-.035.033-.054.049z",
    transform: "translate(334.281 89.665)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2819"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2818",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2808"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3680",
    d: "m193.818 272.057-.035 11.433a1.126 1.126 0 0 0 .658.922l.035-11.433a1.126 1.126 0 0 1-.658-.922z",
    transform: "translate(334.281 90.84)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2807",
    style: {
      clipPath: "url(#pwe17l3urH)"
    },
    transform: "translate(528.064 362.897)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2806",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3681",
    d: "m193.818 272.057-.035 11.433a.788.788 0 0 0 .065.31l.034-11.433a.807.807 0 0 1-.064-.31z",
    transform: "translate(-193.783 -272.057)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3682",
    d: "m193.877 272.343-.034 11.433a1.348 1.348 0 0 0 .593.612l.035-11.433a1.357 1.357 0 0 1-.594-.612z",
    transform: "translate(-193.778 -272.033)",
    style: {
      fill: "#dae8fd"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2811"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3684",
    d: "m241.629 283.478.035-11.433a1.135 1.135 0 0 1-.669.935l-.035 11.433a1.133 1.133 0 0 0 .669-.935z",
    transform: "translate(338.284 90.839)",
    style: {
      fill: "#c6d5fa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2810",
    style: {
      clipPath: "url(#pxt0k30v7I)"
    },
    transform: "translate(579.244 362.884)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2809",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3685",
    d: "m240.995 272.98-.035 11.433a1.133 1.133 0 0 0 .669-.935l.035-11.433a1.135 1.135 0 0 1-.669.935z",
    transform: "translate(-240.96 -272.045)",
    style: {
      fill: "#c6d5fa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2812"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3687",
    d: "m194.425 272.907-.034 11.433 23.58 13.7.029-11.43z",
    transform: "translate(334.333 90.912)",
    style: {
      fill: "#dae8fd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2813"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3688",
    d: "m219.117 286.61-.034 11.433 23.734-13.7.035-11.433z",
    transform: "translate(336.428 90.912)",
    style: {
      fill: "#c6d5fa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2816",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2815",
    style: {
      clipPath: "url(#zkmbbd9noJ)"
    },
    transform: "translate(552.303 377.522)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2814",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3689",
    d: "m216.161 285.539-.035 11.433a3.285 3.285 0 0 0 1.642.384l.035-11.433a3.274 3.274 0 0 1-1.642-.384z",
    transform: "translate(-216.126 -285.539)",
    style: {
      fill: "#d4e2fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3690",
    d: "m217.675 285.923-.035 11.433a3.273 3.273 0 0 0 1.564-.384l.035-11.433a3.276 3.276 0 0 1-1.564.384z",
    transform: "translate(-215.998 -285.539)",
    style: {
      fill: "#cddcfb"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2817"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3692",
    d: "M194.484 272.3a.981.981 0 0 0-.011 1.857l23.58 13.7a3.539 3.539 0 0 0 3.207 0l23.734-13.7a.981.981 0 0 0 .011-1.857l-23.58-13.7a3.532 3.532 0 0 0-3.207 0z",
    transform: "translate(334.284 89.665)",
    style: {
      fill: "#98a4e0"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2821"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3693",
    d: "m194.614 283.326 23 13.278v-8.887l-23-13.278z",
    transform: "translate(334.351 91.042)",
    style: {
      fill: "#3c6ff7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2824"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2822"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3694",
    d: "m212.175 285.951 3.217 1.857v2.544l-3.217-1.857z",
    transform: "translate(335.842 92.019)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3695",
    d: "m202.14 282.7-6.979-4.03v-2.545l6.979 4.03z",
    transform: "translate(334.398 91.186)",
    style: {
      fill: "#15d9fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3696",
    d: "m211.631 288.181-8.617-4.975v-2.545l8.617 4.975z",
    transform: "translate(335.064 91.57)",
    style: {
      fill: "#eff6fe"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2823"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3697",
    d: "m204.872 287.94 1.754 1.013v-2.545l-1.754-1.012z",
    transform: "translate(335.222 91.972)",
    style: {
      fill: "#15d9fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3698",
    d: "m195.161 282.334 1.754 1.012V280.8l-1.754-1.012z",
    transform: "translate(334.398 91.496)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3699",
    d: "m197.895 281.367 6.486 3.744v2.545l-6.486-3.744z",
    transform: "translate(334.63 91.63)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3700",
    d: "m207.6 286.968 8.186 4.726v2.545l-8.185-4.725z",
    transform: "translate(335.453 92.105)",
    style: {
      fill: "#eff6fe"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2845"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2840"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3701",
    d: "M193.8 261.334v-.018l-.035 11.433a.8.8 0 0 0 .015.143c0 .014.008.029.011.043a.8.8 0 0 0 .031.1l.008.025.012.022a.974.974 0 0 0 .066.123l.016.027a1.247 1.247 0 0 0 .115.141l.036.035c.036.035.074.069.116.1l.047.037a1.73 1.73 0 0 0 .187.124l23.579 13.7a2.556 2.556 0 0 0 .36.169c.042.016.09.027.135.041.087.028.174.059.265.079.055.013.113.019.169.029.086.015.169.033.256.042.062.007.125.007.188.01.084.005.166.012.251.012h.02c.076 0 .15-.01.225-.014s.123-.005.182-.012c.085-.01.166-.027.248-.042.055-.011.113-.017.167-.03.089-.022.174-.051.258-.078.043-.015.09-.025.131-.041a2.581 2.581 0 0 0 .354-.166l23.733-13.7a1.138 1.138 0 0 0 .67-.935l.034-11.432a1.126 1.126 0 0 0-.659-.925l-23.58-13.7a3.533 3.533 0 0 0-3.207 0l-23.734 13.7a1.121 1.121 0 0 0-.67.958zm.013.122c0 .016.008.031.011.048 0-.014-.008-.029-.011-.043zm.259.483.037.036c-.009-.014-.022-.024-.033-.036zm.152.139.035.027zm-.37-.478.013.03-.013-.028zm51.7.082a.609.609 0 0 0 .024-.056.609.609 0 0 1-.022.055zm.084-.248c0-.02 0-.04.005-.06 0 .019 0 .039-.003.059zm-.031.125c.007-.018.01-.038.015-.058-.004.019-.007.038-.014.057zm-.219.362c.015-.017.027-.036.041-.053-.013.016-.029.032-.04.052zm.093-.117c.013-.018.022-.036.034-.054-.015.017-.015.035-.033.05zm-.344.335.04-.031-.038.03zm.136-.106c.018-.016.034-.033.051-.05-.016.017-.031.033-.05.049z",
    transform: "translate(334.28 88.654)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2839"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2838",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2828"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3702",
    d: "m193.8 260.141-.035 11.433a1.125 1.125 0 0 0 .66.922l.034-11.433a1.125 1.125 0 0 1-.659-.922z",
    transform: "translate(334.28 89.829)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2827",
    style: {
      clipPath: "url(#hlaqcrvajK)"
    },
    transform: "translate(528.047 349.97)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2826",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3703",
    d: "m193.8 260.141-.035 11.433a.829.829 0 0 0 .065.31l.035-11.433a.788.788 0 0 1-.065-.31z",
    transform: "translate(-193.767 -260.141)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3704",
    d: "m193.862 260.427-.035 11.433a1.345 1.345 0 0 0 .594.612l.034-11.433a1.343 1.343 0 0 1-.593-.612z",
    transform: "translate(-193.762 -260.117)",
    style: {
      fill: "#dae8fd"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2831"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3706",
    d: "m241.613 271.562.035-11.433a1.133 1.133 0 0 1-.669.935l-.035 11.433a1.132 1.132 0 0 0 .669-.935z",
    transform: "translate(338.283 89.828)",
    style: {
      fill: "#c6d5fa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2830",
    style: {
      clipPath: "url(#2hugn5x2iL)"
    },
    transform: "translate(579.227 349.957)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2829",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3707",
    d: "m240.979 261.064-.035 11.433a1.132 1.132 0 0 0 .669-.935l.035-11.433a1.133 1.133 0 0 1-.669.935z",
    transform: "translate(-240.944 -260.129)",
    style: {
      fill: "#c6d5fa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2832"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3709",
    d: "m194.409 260.991-.034 11.433 23.58 13.7.034-11.433z",
    transform: "translate(334.331 89.901)",
    style: {
      fill: "#dae8fd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2833"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3710",
    d: "m219.1 274.694-.034 11.433 23.734-13.7.034-11.433z",
    transform: "translate(336.426 89.901)",
    style: {
      fill: "#c6d5fa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2836",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2835",
    style: {
      clipPath: "url(#1cbbp9l7bM)"
    },
    transform: "translate(552.286 364.595)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2834",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3711",
    d: "m216.145 273.623-.035 11.433a3.277 3.277 0 0 0 1.642.384l.035-11.433a3.271 3.271 0 0 1-1.642-.384z",
    transform: "translate(-216.11 -273.623)",
    style: {
      fill: "#d4e2fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3712",
    d: "m217.659 274.007-.035 11.433a3.268 3.268 0 0 0 1.565-.384l.034-11.433a3.264 3.264 0 0 1-1.564.384z",
    transform: "translate(-215.982 -273.623)",
    style: {
      fill: "#cddcfb"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2837"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3714",
    d: "M194.468 260.381a.981.981 0 0 0-.011 1.857l23.58 13.7a3.539 3.539 0 0 0 3.207 0l23.734-13.7a.981.981 0 0 0 .011-1.857l-23.58-13.7a3.533 3.533 0 0 0-3.207 0z",
    transform: "translate(334.283 88.654)",
    style: {
      fill: "#98a4e0"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2841"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3715",
    d: "m194.6 271.411 23 13.277V275.8l-23-13.277z",
    transform: "translate(334.351 90.031)",
    style: {
      fill: "#3c6ff7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2844"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2842"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3716",
    d: "m212.159 274.034 3.217 1.858v2.545l-3.217-1.857z",
    transform: "translate(335.84 91.008)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3717",
    d: "m202.125 270.786-6.979-4.03v-2.545l6.979 4.03z",
    transform: "translate(334.397 90.174)",
    style: {
      fill: "#15d9fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3718",
    d: "M211.615 276.265 203 271.29v-2.545l8.616 4.974z",
    transform: "translate(335.063 90.559)",
    style: {
      fill: "#eff6fe"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2843"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3719",
    d: "m204.856 276.024 1.754 1.013v-2.545l-1.754-1.012z",
    transform: "translate(335.221 90.961)",
    style: {
      fill: "#15d9fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3720",
    d: "m195.145 270.418 1.754 1.012v-2.545l-1.754-1.013z",
    transform: "translate(334.397 90.485)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3721",
    d: "m197.879 269.451 6.486 3.745v2.545L197.879 272z",
    transform: "translate(334.629 90.619)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3722",
    d: "m207.58 275.052 8.185 4.726v2.545l-8.185-4.723z",
    transform: "translate(335.452 91.094)",
    style: {
      fill: "#eff6fe"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2865"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2860"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3723",
    d: "M193.82 249.356v-.017l-.035 11.433a.8.8 0 0 0 .015.142c0 .014.008.029.011.043a.809.809 0 0 0 .031.1l.008.025.012.022a.952.952 0 0 0 .066.123c.007.009.011.018.017.028a1.323 1.323 0 0 0 .114.141l.035.034a1.372 1.372 0 0 0 .117.1l.048.038a1.876 1.876 0 0 0 .184.124l23.58 13.7a2.446 2.446 0 0 0 .36.17c.043.016.09.026.135.041.087.028.172.058.265.079.055.013.113.018.169.029.086.015.169.033.256.041.062.007.125.007.188.011.084 0 .166.012.25.011a.136.136 0 0 0 .021 0c.075 0 .15-.009.225-.014s.123 0 .182-.012c.085-.01.166-.027.248-.042.055-.011.113-.017.167-.029.089-.022.173-.051.257-.079.044-.014.09-.025.133-.041a2.425 2.425 0 0 0 .352-.166l23.734-13.7a1.134 1.134 0 0 0 .669-.935l.035-11.432a1.124 1.124 0 0 0-.659-.925l-23.58-13.7a3.536 3.536 0 0 0-3.207 0l-23.734 13.7a1.123 1.123 0 0 0-.669.957zm.012.123c0 .015.008.031.012.047 0-.015-.009-.029-.011-.044zm.26.483.037.036c-.013-.014-.029-.024-.037-.036zm.152.138.035.027zm-.37-.477.012.03-.012-.028zm51.7.082c.01-.02.016-.038.024-.058-.009.02-.016.038-.026.053zm.084-.25c0-.02 0-.039.005-.06-.004.021-.004.04-.007.06zm-.031.126c.007-.02.01-.039.015-.059-.008.02-.011.039-.018.059zm-.219.361c.015-.017.027-.035.041-.052-.017.017-.029.035-.044.052zm.093-.117c.013-.017.022-.036.033-.053-.014.017-.023.036-.034.053zm-.344.336.04-.033zm.136-.106c.018-.016.034-.034.051-.05-.02.016-.035.034-.054.05z",
    transform: "translate(334.281 87.637)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2859"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2858",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2848"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3724",
    d: "m193.818 248.164-.035 11.433a1.127 1.127 0 0 0 .658.922l.035-11.433a1.126 1.126 0 0 1-.658-.922z",
    transform: "translate(334.281 88.812)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2847",
    style: {
      clipPath: "url(#vgeb7osu1N)"
    },
    transform: "translate(528.064 336.976)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2846",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3725",
    d: "m193.818 248.164-.035 11.433a.787.787 0 0 0 .065.309l.034-11.433a.8.8 0 0 1-.064-.309z",
    transform: "translate(-193.783 -248.164)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3726",
    d: "m193.877 248.449-.034 11.433a1.35 1.35 0 0 0 .593.613l.035-11.433a1.359 1.359 0 0 1-.594-.613z",
    transform: "translate(-193.778 -248.14)",
    style: {
      fill: "#dae8fd"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2851"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3728",
    d: "m241.629 259.585.035-11.433a1.134 1.134 0 0 1-.669.935l-.035 11.433a1.134 1.134 0 0 0 .669-.935z",
    transform: "translate(338.284 88.811)",
    style: {
      fill: "#c6d5fa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2850",
    style: {
      clipPath: "url(#arrj4lfnqO)"
    },
    transform: "translate(579.244 336.963)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2849",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3729",
    d: "m240.995 249.087-.035 11.433a1.134 1.134 0 0 0 .669-.935l.035-11.433a1.134 1.134 0 0 1-.669.935z",
    transform: "translate(-240.96 -248.152)",
    style: {
      fill: "#c6d5fa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2852"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3731",
    d: "m194.425 249.014-.034 11.433 23.58 13.7.029-11.43z",
    transform: "translate(334.333 88.884)",
    style: {
      fill: "#dae8fd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2853"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3732",
    d: "m219.117 262.717-.034 11.433 23.734-13.7.035-11.433z",
    transform: "translate(336.428 88.884)",
    style: {
      fill: "#c6d5fa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2856",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2855",
    style: {
      clipPath: "url(#xbsra2okgP)"
    },
    transform: "translate(552.303 351.601)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2854",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3733",
    d: "m216.161 261.645-.035 11.433a3.274 3.274 0 0 0 1.642.384l.035-11.432a3.285 3.285 0 0 1-1.642-.385z",
    transform: "translate(-216.126 -261.645)",
    style: {
      fill: "#d4e2fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3734",
    d: "m217.675 262.03-.035 11.432a3.249 3.249 0 0 0 1.564-.384l.035-11.433a3.264 3.264 0 0 1-1.564.385z",
    transform: "translate(-215.998 -261.645)",
    style: {
      fill: "#cddcfb"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2857"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3736",
    d: "M194.484 248.4a.981.981 0 0 0-.011 1.857l23.58 13.7a3.532 3.532 0 0 0 3.207 0l23.734-13.7a.981.981 0 0 0 .011-1.857l-23.58-13.7a3.536 3.536 0 0 0-3.207 0z",
    transform: "translate(334.284 87.637)",
    style: {
      fill: "#ecf5fe"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2861"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3737",
    d: "m194.614 259.433 23 13.278v-8.887l-23-13.278z",
    transform: "translate(334.351 89.014)",
    style: {
      fill: "#3c6ff7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2864"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2862"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3738",
    d: "m212.175 262.057 3.217 1.857v2.545l-3.217-1.857z",
    transform: "translate(335.842 89.991)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3739",
    d: "m202.14 258.808-6.979-4.029v-2.545l6.979 4.03z",
    transform: "translate(334.398 89.158)",
    style: {
      fill: "#15d9fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3740",
    d: "m211.631 264.287-8.617-4.974v-2.545l8.617 4.975z",
    transform: "translate(335.064 89.543)",
    style: {
      fill: "#eff6fe"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2863"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3741",
    d: "m204.872 264.047 1.754 1.012v-2.545l-1.754-1.013z",
    transform: "translate(335.222 89.944)",
    style: {
      fill: "#15d9fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3742",
    d: "m195.161 258.44 1.754 1.012v-2.545l-1.754-1.012z",
    transform: "translate(334.398 89.468)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3743",
    d: "m197.895 257.474 6.486 3.744v2.545l-6.486-3.744z",
    transform: "translate(334.63 89.602)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3744",
    d: "m207.6 263.074 8.186 4.725v2.545l-8.185-4.725z",
    transform: "translate(335.453 90.077)",
    style: {
      fill: "#eff6fe"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3745",
    d: "M237.147 249.609a2.015 2.015 0 0 1-.707.635l-15.1 8.719a4.858 4.858 0 0 1-4.4 0l-15.1-8.719a2.014 2.014 0 0 1-.707-.635c-.422-.639-.183-1.391.707-1.9l15.1-8.72a4.865 4.865 0 0 1 4.4 0l15.1 8.72c.89.509 1.129 1.261.707 1.9z",
    transform: "translate(334.887 87.989)",
    style: {
      fill: "#c6d5fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3746",
    d: "M237.131 249.51a2.014 2.014 0 0 1-.707.635l-15.1 8.719a4.858 4.858 0 0 1-4.4 0l-15.1-8.719a.638.638 0 1 1 0-1.269l15.1-8.722a4.858 4.858 0 0 1 4.4 0l15.1 8.722a2.014 2.014 0 0 1 .707.634z",
    transform: "translate(334.903 88.088)",
    style: {
      fill: "#15d9fd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2948"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2886"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2881"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3747",
    d: "M220.544 312.542v-.017l-.035 11.433a.712.712 0 0 0 .015.142.336.336 0 0 0 .011.044.852.852 0 0 0 .03.1l.008.024.013.023a.839.839 0 0 0 .066.121l.016.028a1.345 1.345 0 0 0 .115.141l.035.035c.036.035.075.069.117.1l.047.038a2.049 2.049 0 0 0 .186.124l23.58 13.7a2.489 2.489 0 0 0 .359.17c.043.016.091.026.136.041.087.028.172.057.264.079.055.013.114.018.17.029.085.015.168.033.255.042.063.006.126.006.188.01.084.005.167.012.251.012h.021c.075 0 .15-.01.223-.015s.123 0 .183-.012c.085-.01.165-.027.247-.042.056-.01.113-.017.168-.029.089-.022.172-.051.257-.079.043-.014.09-.024.132-.041a2.29 2.29 0 0 0 .353-.166l23.734-13.7a1.134 1.134 0 0 0 .669-.935l.035-11.433a1.121 1.121 0 0 0-.657-.925l-23.58-13.7a3.539 3.539 0 0 0-3.207 0l-23.735 13.7a1.122 1.122 0 0 0-.67.958zm.013.123c0 .016.008.031.012.047 0-.015-.009-.029-.012-.045zm.259.483.036.036zm.153.139.035.027zm-.37-.478.012.03-.012-.028zm51.7.083.024-.057a.213.213 0 0 0-.023.056zm.083-.25c0-.02 0-.039.005-.059-.003.017-.003.038-.006.058zm-.031.126a.558.558 0 0 0 .014-.058c-.006.018-.009.037-.016.057zm-.22.361c.016-.017.028-.035.042-.052-.016.016-.028.034-.044.051zm.094-.117c.012-.017.022-.036.033-.053-.013.016-.023.035-.035.052zm-.345.336.041-.033-.043.032zm.136-.106c.018-.016.034-.034.051-.05-.019.015-.034.033-.053.049z",
    transform: "translate(336.549 92.998)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2880"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2879",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2869"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3748",
    d: "m220.543 311.35-.035 11.433a1.126 1.126 0 0 0 .659.922l.035-11.433a1.126 1.126 0 0 1-.659-.922z",
    transform: "translate(336.549 94.173)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2868",
    style: {
      clipPath: "url(#okr6a6eklQ)"
    },
    transform: "translate(557.057 405.523)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2867",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3749",
    d: "m220.543 311.35-.035 11.433a.8.8 0 0 0 .064.309l.035-11.433a.8.8 0 0 1-.064-.309z",
    transform: "translate(-220.508 -311.35)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3750",
    d: "m220.6 311.635-.035 11.433a1.353 1.353 0 0 0 .594.613l.035-11.433a1.353 1.353 0 0 1-.595-.613z",
    transform: "translate(-220.503 -311.326)",
    style: {
      fill: "#dae8fd"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2872"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3752",
    d: "m268.354 322.771.035-11.433a1.135 1.135 0 0 1-.669.935l-.035 11.433a1.135 1.135 0 0 0 .669-.935z",
    transform: "translate(340.552 94.172)",
    style: {
      fill: "#c6d5fa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2871",
    style: {
      clipPath: "url(#3lnzep9oyR)"
    },
    transform: "translate(608.237 405.51)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2870",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3753",
    d: "m267.72 312.273-.035 11.433a1.135 1.135 0 0 0 .669-.935l.035-11.433a1.135 1.135 0 0 1-.669.935z",
    transform: "translate(-267.685 -311.338)",
    style: {
      fill: "#c6d5fa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2873"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3755",
    d: "m221.15 312.2-.034 11.433 23.58 13.7.035-11.433z",
    transform: "translate(336.601 94.245)",
    style: {
      fill: "#dae8fd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2874"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3756",
    d: "m245.842 325.9-.034 11.433 23.734-13.7.035-11.433z",
    transform: "translate(338.696 94.245)",
    style: {
      fill: "#c6d5fa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2877",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2876",
    style: {
      clipPath: "url(#9uit7coi0S)"
    },
    transform: "translate(581.296 420.148)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2875",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3757",
    d: "m242.886 324.831-.035 11.433a3.282 3.282 0 0 0 1.642.385l.035-11.433a3.282 3.282 0 0 1-1.642-.385z",
    transform: "translate(-242.851 -324.831)",
    style: {
      fill: "#d4e2fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3758",
    d: "m244.4 325.216-.035 11.433a3.267 3.267 0 0 0 1.564-.385l.035-11.433a3.267 3.267 0 0 1-1.564.385z",
    transform: "translate(-242.723 -324.831)",
    style: {
      fill: "#cddcfb"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2878"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3760",
    d: "M221.208 311.59a.982.982 0 0 0-.01 1.857l23.58 13.7a3.533 3.533 0 0 0 3.207 0l23.734-13.7a.982.982 0 0 0 .011-1.857l-23.58-13.7a3.539 3.539 0 0 0-3.207 0z",
    transform: "translate(336.552 92.998)",
    style: {
      fill: "#98a4e0"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2882"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3761",
    d: "m221.339 322.619 23 13.277v-8.887l-23-13.277z",
    transform: "translate(336.619 94.375)",
    style: {
      fill: "#3c6ff7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2885"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2883"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3762",
    d: "m238.9 325.243 3.217 1.858v2.545l-3.217-1.857z",
    transform: "translate(338.11 95.352)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3763",
    d: "m228.865 321.994-6.979-4.03v-2.544l6.979 4.03z",
    transform: "translate(336.666 94.519)",
    style: {
      fill: "#15d9fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3764",
    d: "m238.355 327.473-8.616-4.975v-2.545l8.616 4.974z",
    transform: "translate(337.333 94.903)",
    style: {
      fill: "#eff6fe"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2884"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3765",
    d: "m231.6 327.233 1.754 1.012V325.7l-1.754-1.012z",
    transform: "translate(337.49 95.305)",
    style: {
      fill: "#15d9fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3766",
    d: "m221.886 321.626 1.754 1.012v-2.544l-1.754-1.013z",
    transform: "translate(336.666 94.83)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3767",
    d: "m224.619 320.66 6.486 3.744v2.545l-6.486-3.744z",
    transform: "translate(336.898 94.963)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3768",
    d: "m234.32 326.261 8.186 4.725v2.545l-8.185-4.725z",
    transform: "translate(337.721 95.439)",
    style: {
      fill: "#eff6fe"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2906"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2901"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3769",
    d: "M220.544 300.626v-.017l-.035 11.433a.7.7 0 0 0 .015.142.336.336 0 0 0 .011.044.856.856 0 0 0 .03.1l.008.024a.148.148 0 0 0 .013.022.752.752 0 0 0 .066.123l.016.028a1.232 1.232 0 0 0 .115.141l.035.035c.036.035.075.069.117.1l.047.038a2.048 2.048 0 0 0 .186.124l23.58 13.7a2.485 2.485 0 0 0 .359.17c.043.016.091.026.136.041.087.028.172.057.264.079.055.013.114.018.17.029.085.015.168.033.255.042.063.007.126.007.188.01.084 0 .167.012.251.012h.021c.075 0 .15-.01.223-.015s.123 0 .183-.011c.085-.011.165-.028.247-.043.056-.01.113-.016.168-.029.089-.022.172-.051.257-.079.043-.014.09-.024.132-.04a2.4 2.4 0 0 0 .353-.167l23.734-13.7a1.134 1.134 0 0 0 .669-.935l.035-11.433a1.121 1.121 0 0 0-.657-.925l-23.58-13.7a3.539 3.539 0 0 0-3.207 0l-23.735 13.7a1.123 1.123 0 0 0-.67.957zm.013.123c0 .016.008.032.012.047 0-.014-.009-.029-.012-.044zm.259.483c.011.013.024.024.036.036zm.153.139.035.027zm-.37-.478.012.03-.012-.028zm51.7.082c.009-.018.015-.038.024-.056-.011.017-.017.037-.023.055zm.083-.248c0-.021 0-.04.005-.06-.003.019-.003.038-.006.059zm-.031.125a.556.556 0 0 0 .014-.058.556.556 0 0 1-.016.057zm-.22.361c.016-.017.028-.035.042-.052-.016.016-.028.034-.044.051zm.094-.117c.012-.017.022-.036.033-.053-.013.016-.023.035-.035.052zm-.345.336.041-.033-.043.032zm.136-.106c.018-.016.034-.034.051-.05-.019.015-.034.033-.053.049z",
    transform: "translate(336.549 91.987)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2900"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2899",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2889"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3770",
    d: "m220.543 299.434-.035 11.433a1.126 1.126 0 0 0 .659.922l.035-11.433a1.126 1.126 0 0 1-.659-.922z",
    transform: "translate(336.549 93.162)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2888",
    style: {
      clipPath: "url(#oxlcmgjkwT)"
    },
    transform: "translate(557.057 392.596)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2887",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3771",
    d: "m220.543 299.434-.035 11.433a.8.8 0 0 0 .064.309l.035-11.432a.806.806 0 0 1-.064-.31z",
    transform: "translate(-220.508 -299.434)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3772",
    d: "m220.6 299.72-.035 11.432a1.353 1.353 0 0 0 .594.613l.035-11.433a1.356 1.356 0 0 1-.595-.612z",
    transform: "translate(-220.503 -299.41)",
    style: {
      fill: "#dae8fd"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2892"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3774",
    d: "m268.354 310.855.035-11.433a1.135 1.135 0 0 1-.669.935l-.035 11.433a1.135 1.135 0 0 0 .669-.935z",
    transform: "translate(340.552 93.161)",
    style: {
      fill: "#c6d5fa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2891",
    style: {
      clipPath: "url(#e4mmsifurU)"
    },
    transform: "translate(608.237 392.583)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2890",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3775",
    d: "m267.72 300.357-.035 11.433a1.135 1.135 0 0 0 .669-.935l.035-11.433a1.135 1.135 0 0 1-.669.935z",
    transform: "translate(-267.685 -299.422)",
    style: {
      fill: "#c6d5fa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2893"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3777",
    d: "m221.15 300.284-.034 11.433 23.58 13.7.035-11.433z",
    transform: "translate(336.601 93.234)",
    style: {
      fill: "#dae8fd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2894"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3778",
    d: "m245.842 313.987-.034 11.433 23.734-13.7.035-11.433z",
    transform: "translate(338.696 93.234)",
    style: {
      fill: "#c6d5fa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2897",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2896",
    style: {
      clipPath: "url(#ldesisfy8V)"
    },
    transform: "translate(581.296 407.221)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2895",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3779",
    d: "m242.886 312.915-.035 11.433a3.283 3.283 0 0 0 1.642.385l.035-11.433a3.271 3.271 0 0 1-1.642-.385z",
    transform: "translate(-242.851 -312.915)",
    style: {
      fill: "#d4e2fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3780",
    d: "m244.4 313.3-.035 11.433a3.268 3.268 0 0 0 1.564-.385l.035-11.433a3.254 3.254 0 0 1-1.564.385z",
    transform: "translate(-242.723 -312.915)",
    style: {
      fill: "#cddcfb"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2898"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3782",
    d: "M221.208 299.674a.982.982 0 0 0-.01 1.857l23.58 13.7a3.533 3.533 0 0 0 3.207 0l23.734-13.7a.982.982 0 0 0 .011-1.857l-23.58-13.7a3.539 3.539 0 0 0-3.207 0z",
    transform: "translate(336.552 91.987)",
    style: {
      fill: "#98a4e0"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2902"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3783",
    d: "m221.339 310.7 23 13.278v-8.887l-23-13.278z",
    transform: "translate(336.619 93.364)",
    style: {
      fill: "#3c6ff7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2905"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2903"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3784",
    d: "m238.9 313.327 3.217 1.857v2.545l-3.217-1.857z",
    transform: "translate(338.11 94.341)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3785",
    d: "m228.865 310.079-6.979-4.03V303.5l6.979 4.029z",
    transform: "translate(336.666 93.508)",
    style: {
      fill: "#15d9fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3786",
    d: "m238.355 315.558-8.616-4.974v-2.545l8.616 4.975z",
    transform: "translate(337.333 93.892)",
    style: {
      fill: "#eff6fe"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2904"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3787",
    d: "m231.6 315.317 1.754 1.012v-2.545l-1.754-1.013z",
    transform: "translate(337.49 94.294)",
    style: {
      fill: "#15d9fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3788",
    d: "m221.886 309.71 1.754 1.013v-2.545l-1.754-1.012z",
    transform: "translate(336.666 93.818)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3789",
    d: "m224.619 308.744 6.486 3.745v2.545l-6.486-3.744z",
    transform: "translate(336.898 93.952)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3790",
    d: "m234.32 314.345 8.186 4.726v2.545l-8.185-4.725z",
    transform: "translate(337.721 94.427)",
    style: {
      fill: "#eff6fe"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2926"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2921"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3791",
    d: "M220.56 288.71v-.017l-.034 11.433a.693.693 0 0 0 .015.142.332.332 0 0 0 .011.044.685.685 0 0 0 .03.1l.008.025.012.022a.9.9 0 0 0 .067.121.233.233 0 0 0 .016.028 1.13 1.13 0 0 0 .115.141l.035.035c.036.036.075.069.117.1l.047.037a2.05 2.05 0 0 0 .185.124l23.58 13.7a2.6 2.6 0 0 0 .359.169c.043.016.091.027.136.041.087.028.172.059.264.079.055.013.114.02.17.029.085.015.168.033.255.042.063.007.125.007.188.01.084.005.167.013.251.012h.021c.075 0 .15-.01.224-.015s.123 0 .183-.011c.084-.01.165-.028.247-.043.056-.01.113-.016.168-.029.089-.022.172-.051.257-.078.043-.015.09-.025.132-.041a2.386 2.386 0 0 0 .353-.167l23.734-13.7a1.135 1.135 0 0 0 .669-.935l.035-11.433a1.121 1.121 0 0 0-.658-.925l-23.579-13.7a3.539 3.539 0 0 0-3.207 0l-23.734 13.7a1.122 1.122 0 0 0-.672.96zm.013.123c0 .016.008.031.012.048 0-.015-.009-.029-.012-.044zm.259.483a.385.385 0 0 0 .037.036zm.152.139.035.028zm-.37-.478.013.03-.012-.028zm51.7.082c.01-.018.016-.038.025-.056-.011.018-.017.037-.027.056zm.085-.248c0-.021 0-.04.005-.06-.004.019-.004.038-.004.059zm-.033.125a.347.347 0 0 0 .015-.057.377.377 0 0 1-.017.056zm-.219.361c.015-.016.028-.035.042-.052-.016.016-.029.035-.044.055zm.094-.117c.013-.017.022-.036.033-.053-.013.016-.023.035-.035.052zm-.345.336c.015-.011.027-.022.041-.031-.015.009-.027.015-.042.03zm.136-.106c.018-.016.034-.034.051-.05-.019.015-.034.033-.053.049z",
    transform: "translate(336.55 90.976)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2920"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2919",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2909"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3792",
    d: "m220.558 287.518-.034 11.433a1.124 1.124 0 0 0 .658.922l.035-11.433a1.128 1.128 0 0 1-.659-.922z",
    transform: "translate(336.55 92.151)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2908",
    style: {
      clipPath: "url(#z9q5swh1rW)"
    },
    transform: "translate(557.074 379.669)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2907",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3793",
    d: "m220.558 287.518-.034 11.433a.807.807 0 0 0 .064.31l.035-11.433a.829.829 0 0 1-.065-.31z",
    transform: "translate(-220.524 -287.518)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3794",
    d: "m220.618 287.8-.035 11.433a1.351 1.351 0 0 0 .594.612l.035-11.433a1.351 1.351 0 0 1-.594-.612z",
    transform: "translate(-220.519 -287.494)",
    style: {
      fill: "#dae8fd"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2912"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3796",
    d: "m268.37 298.939.035-11.433a1.137 1.137 0 0 1-.669.935l-.035 11.433a1.135 1.135 0 0 0 .669-.935z",
    transform: "translate(340.553 92.15)",
    style: {
      fill: "#c6d5fa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2911",
    style: {
      clipPath: "url(#yiph7xbylX)"
    },
    transform: "translate(608.254 379.656)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2910",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3797",
    d: "m267.736 288.441-.035 11.433a1.135 1.135 0 0 0 .669-.935l.035-11.433a1.137 1.137 0 0 1-.669.935z",
    transform: "translate(-267.701 -287.506)",
    style: {
      fill: "#c6d5fa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2913"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3799",
    d: "m221.165 288.368-.034 11.433 23.58 13.7.034-11.433z",
    transform: "translate(336.602 92.223)",
    style: {
      fill: "#dae8fd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2914"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3800",
    d: "m245.857 302.071-.035 11.433 23.734-13.7.034-11.433z",
    transform: "translate(338.696 92.223)",
    style: {
      fill: "#c6d5fa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2917",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2916",
    style: {
      clipPath: "url(#q1gg1spe6Y)"
    },
    transform: "translate(581.313 394.295)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2915",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3801",
    d: "m242.9 301-.034 11.432a3.272 3.272 0 0 0 1.642.385l.035-11.433A3.279 3.279 0 0 1 242.9 301z",
    transform: "translate(-242.867 -301)",
    style: {
      fill: "#d4e2fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3802",
    d: "m244.416 301.384-.035 11.433a3.268 3.268 0 0 0 1.564-.385L245.98 301a3.28 3.28 0 0 1-1.564.384z",
    transform: "translate(-242.739 -301)",
    style: {
      fill: "#cddcfb"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2918"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3804",
    d: "M221.225 287.758a.981.981 0 0 0-.011 1.857l23.579 13.7a3.541 3.541 0 0 0 3.208 0l23.734-13.7a.981.981 0 0 0 .01-1.857l-23.579-13.7a3.539 3.539 0 0 0-3.207 0z",
    transform: "translate(336.552 90.976)",
    style: {
      fill: "#98a4e0"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2922"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3805",
    d: "m221.355 298.787 23 13.277v-8.887l-23-13.277z",
    transform: "translate(336.62 92.353)",
    style: {
      fill: "#3c6ff7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2925"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2923"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3806",
    d: "m238.916 301.411 3.217 1.857v2.545l-3.217-1.857z",
    transform: "translate(338.11 93.33)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3807",
    d: "m228.881 298.162-6.979-4.029v-2.545l6.979 4.029z",
    transform: "translate(336.666 92.497)",
    style: {
      fill: "#15d9fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3808",
    d: "m238.371 303.642-8.617-4.974v-2.545l8.617 4.974z",
    transform: "translate(337.333 92.881)",
    style: {
      fill: "#eff6fe"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2924"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3809",
    d: "m231.612 303.4 1.754 1.013v-2.545l-1.754-1.012z",
    transform: "translate(337.49 93.283)",
    style: {
      fill: "#15d9fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3810",
    d: "m221.9 297.795 1.754 1.012v-2.545l-1.754-1.012z",
    transform: "translate(336.667 92.807)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3811",
    d: "m224.635 296.828 6.486 3.745v2.545l-6.486-3.745z",
    transform: "translate(336.899 92.941)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3812",
    d: "m234.336 302.429 8.185 4.726v2.545l-8.185-4.726z",
    transform: "translate(337.722 93.416)",
    style: {
      fill: "#eff6fe"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2946"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2941"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3813",
    d: "M220.544 276.8v-.018l-.035 11.433a.7.7 0 0 0 .015.142.3.3 0 0 0 .011.044.855.855 0 0 0 .03.1c0 .008 0 .016.008.025a.233.233 0 0 0 .013.022.785.785 0 0 0 .066.121l.016.028a1.244 1.244 0 0 0 .115.141l.035.035a.935.935 0 0 0 .117.1l.047.037a2.055 2.055 0 0 0 .186.124l23.58 13.7a2.475 2.475 0 0 0 .359.169c.043.016.091.027.136.041.087.028.172.059.264.079.055.013.114.02.17.029.085.015.168.033.255.042.063.007.126.007.188.01.084.005.167.012.251.012h.021c.075 0 .15-.01.223-.014s.123-.005.183-.012c.085-.01.165-.027.247-.042.056-.011.113-.017.168-.03.089-.022.172-.05.257-.078.043-.015.09-.025.132-.041a2.515 2.515 0 0 0 .353-.166l23.734-13.7a1.134 1.134 0 0 0 .669-.935l.035-11.433a1.122 1.122 0 0 0-.657-.926l-23.58-13.7a3.532 3.532 0 0 0-3.207 0l-23.735 13.7a1.123 1.123 0 0 0-.67.961zm.013.121c0 .016.008.031.012.048 0-.015-.009-.03-.012-.044zm.259.483.036.036zm.153.139.035.027zm-.37-.478.012.03-.012-.028zm51.7.082c.009-.018.015-.038.024-.056-.011.009-.017.033-.023.052zm.083-.248c0-.02 0-.04.005-.06-.003.015-.003.036-.006.055zm-.031.125a.494.494 0 0 0 .014-.057.494.494 0 0 1-.016.052zm-.22.361a.618.618 0 0 0 .042-.051.618.618 0 0 1-.044.046zm.094-.117c.012-.017.022-.036.033-.053-.013.012-.023.031-.035.048zm-.345.336c.015-.01.027-.021.041-.031-.015.006-.027.016-.043.027zm.136-.106c.018-.016.034-.034.051-.05-.019.011-.034.029-.053.045z",
    transform: "translate(336.549 89.965)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2940"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2939",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2929"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3814",
    d: "m220.543 275.6-.035 11.433a1.126 1.126 0 0 0 .659.922l.035-11.433a1.125 1.125 0 0 1-.659-.922z",
    transform: "translate(336.549 91.14)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2928",
    style: {
      clipPath: "url(#mgh0xloxdZ)"
    },
    transform: "translate(557.057 366.742)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2927",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3815",
    d: "m220.543 275.6-.035 11.433a.807.807 0 0 0 .064.31l.035-11.433a.806.806 0 0 1-.064-.31z",
    transform: "translate(-220.508 -275.602)",
    style: {
      fill: "#dae8fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3816",
    d: "m220.6 275.888-.035 11.433a1.346 1.346 0 0 0 .594.612l.041-11.433a1.346 1.346 0 0 1-.595-.612z",
    transform: "translate(-220.503 -275.578)",
    style: {
      fill: "#dae8fd"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2932"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3818",
    d: "m268.354 287.023.035-11.433a1.136 1.136 0 0 1-.669.936l-.035 11.432a1.135 1.135 0 0 0 .669-.935z",
    transform: "translate(340.552 91.139)",
    style: {
      fill: "#c6d5fa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2931",
    style: {
      clipPath: "url(#z5mq6jc9yaa)"
    },
    transform: "translate(608.237 366.729)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2930",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3819",
    d: "m267.72 276.526-.035 11.432a1.135 1.135 0 0 0 .669-.935l.035-11.433a1.136 1.136 0 0 1-.669.936z",
    transform: "translate(-267.685 -275.59)",
    style: {
      fill: "#c6d5fa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2933"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3821",
    d: "m221.15 276.452-.034 11.433 23.58 13.7.035-11.433z",
    transform: "translate(336.601 91.212)",
    style: {
      fill: "#dae8fd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2934"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3822",
    d: "m245.842 290.156-.034 11.433 23.734-13.7.035-11.433z",
    transform: "translate(338.696 91.211)",
    style: {
      fill: "#c6d5fa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2937",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2936",
    style: {
      clipPath: "url(#tv0awqhhgab)"
    },
    transform: "translate(581.296 381.368)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2935",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3823",
    d: "m242.886 289.084-.035 11.433a3.271 3.271 0 0 0 1.642.384l.035-11.433a3.272 3.272 0 0 1-1.642-.384z",
    transform: "translate(-242.851 -289.084)",
    style: {
      fill: "#d4e2fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3824",
    d: "m244.4 289.468-.035 11.433a3.279 3.279 0 0 0 1.564-.384l.035-11.433a3.267 3.267 0 0 1-1.564.384z",
    transform: "translate(-242.723 -289.084)",
    style: {
      fill: "#cddcfb"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2938"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3826",
    d: "M221.208 275.842a.982.982 0 0 0-.01 1.857l23.58 13.7a3.533 3.533 0 0 0 3.207 0l23.734-13.7a.982.982 0 0 0 .011-1.858l-23.58-13.7a3.532 3.532 0 0 0-3.207 0z",
    transform: "translate(336.552 89.965)",
    style: {
      fill: "#ecf5fe"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2942"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3827",
    d: "m221.339 286.871 23 13.278v-8.887l-23-13.278z",
    transform: "translate(336.619 91.342)",
    style: {
      fill: "#3c6ff7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2945"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2943"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3828",
    d: "m238.9 289.5 3.217 1.858v2.542l-3.217-1.86z",
    transform: "translate(338.11 92.319)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3829",
    d: "m228.865 286.247-6.979-4.029v-2.545l6.979 4.029z",
    transform: "translate(336.666 91.485)",
    style: {
      fill: "#15d9fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3830",
    d: "m238.355 291.726-8.616-4.974v-2.545l8.616 4.974z",
    transform: "translate(337.333 91.87)",
    style: {
      fill: "#eff6fe"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2944"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3831",
    d: "m231.6 291.485 1.754 1.012v-2.545l-1.754-1.012z",
    transform: "translate(337.49 92.272)",
    style: {
      fill: "#15d9fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3832",
    d: "m221.886 285.878 1.754 1.013v-2.545l-1.754-1.012z",
    transform: "translate(336.666 91.796)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3833",
    d: "m224.619 284.912 6.486 3.745v2.543l-6.486-3.745z",
    transform: "translate(336.898 91.93)",
    style: {
      fill: "#eff6fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3834",
    d: "m234.32 290.513 8.186 4.726v2.545l-8.185-4.726z",
    transform: "translate(337.721 92.405)",
    style: {
      fill: "#eff6fe"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2947"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3835",
    d: "M263.888 276.6a2.018 2.018 0 0 1-.708.635l-15.1 8.718a4.854 4.854 0 0 1-4.4 0l-15.1-8.718a2.018 2.018 0 0 1-.708-.635c-.422-.639-.183-1.391.708-1.9l15.1-8.719a4.86 4.86 0 0 1 4.4 0l15.1 8.719c.891.513 1.13 1.265.708 1.9z",
    transform: "translate(337.157 90.279)",
    style: {
      fill: "#c6d5fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3836",
    d: "M263.872 276.5a2.018 2.018 0 0 1-.708.635l-15.1 8.718a4.854 4.854 0 0 1-4.4 0l-15.1-8.718a.639.639 0 1 1 0-1.27l15.1-8.722a4.86 4.86 0 0 1 4.4 0l15.1 8.722a2.021 2.021 0 0 1 .708.635z",
    transform: "translate(337.172 90.378)",
    style: {
      fill: "#15d9fd"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2950"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3837",
    d: "M123.459 230.314c3.649-.727 7.98-.008 12.629 2.336 1.532-4.667 4.451-7.817 8.284-9.187 4.393-1.573 10.019-.8 16.12 2.724a40.8 40.8 0 0 1 6.508 4.727 35.27 35.27 0 0 1 3.046-12.5c3.042-6.456 8.1-10.515 14.456-11.778s14.022.281 22.245 5.028a68.566 68.566 0 0 1 15.46 12.525 94.93 94.93 0 0 1 17.438 26.636 77.773 77.773 0 0 1 6.587 25.527 40.041 40.041 0 0 1 6.3 2.972 59.425 59.425 0 0 1 13.391 10.843 82.27 82.27 0 0 1 15.1 23.07c3.694 8.452 5.842 17.334 5.819 25.512a32.671 32.671 0 0 1-2.751 13.834c-2.634 5.593-7.012 9.107-12.516 10.2s-12.148-.245-19.268-4.356l-114.73-66.235a44.063 44.063 0 0 1-9.927-8.041 60.927 60.927 0 0 1-11.2-17.1 47.971 47.971 0 0 1-4.312-18.914 24.3 24.3 0 0 1 2.037-10.258 12.9 12.9 0 0 1 9.284-7.565zm-4.128 30.868a47.369 47.369 0 0 0 7.173 14.2A37.519 37.519 0 0 0 137.6 285.69l114.726 66.24a27.67 27.67 0 0 0 11.2 3.867 14.6 14.6 0 0 0 12.693-4.669c3.115-3.489 4.944-8.785 4.963-15.643a49.066 49.066 0 0 0-2.224-14.167 68.6 68.6 0 0 0-10.383-20.564 54.437 54.437 0 0 0-16.065-14.927 30.535 30.535 0 0 0-8.186-3.365 3.05 3.05 0 0 1-.807-.331 5.459 5.459 0 0 1-1.692-1.63 6.047 6.047 0 0 1-1.121-3.482 58.081 58.081 0 0 0-2.636-16.794 81.255 81.255 0 0 0-12.3-24.366c-5.43-7.368-11.966-13.606-19.035-17.691a32.863 32.863 0 0 0-13.275-4.581c-6.125-.56-11.35 1.4-15.041 5.534s-5.858 10.412-5.881 18.539c0 .3 0 .6.005.918.02 1.131-.456 1.9-1.266 2.056a2.34 2.34 0 0 1-1.569-.358 4.947 4.947 0 0 1-1.153-.95 34.62 34.62 0 0 0-8.08-6.637c-4.76-2.748-9.107-3.345-12.542-2.121s-5.917 4.282-6.907 8.832c-.291 1.333-1.441 1.727-2.836.921-.159-.1-.315-.188-.462-.273a19.13 19.13 0 0 0-7.736-2.672 10.082 10.082 0 0 0-8.763 3.225c-2.154 2.409-3.415 6.064-3.428 10.8a33.928 33.928 0 0 0 1.534 9.783z",
    transform: "translate(327.355 85.252)",
    style: {
      fill: "#eff6fe"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3838",
    d: "m266.313 357.332 43.717-25.4a18.292 18.292 0 0 0 7.291-8.246 32.667 32.667 0 0 0 2.75-13.834c.024-8.178-2.124-17.059-5.818-25.511a82.28 82.28 0 0 0-15.1-23.07 59.473 59.473 0 0 0-13.391-10.843 40.1 40.1 0 0 0-6.3-2.972l-43.717 25.4a40.037 40.037 0 0 1 6.3 2.972 59.428 59.428 0 0 1 13.391 10.843 82.273 82.273 0 0 1 15.1 23.07c3.694 8.452 5.842 17.334 5.819 25.512a32.671 32.671 0 0 1-2.751 13.834 18.283 18.283 0 0 1-7.291 8.245z",
    transform: "translate(337.842 88.751)",
    style: {
      fill: "#c6d5fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3839",
    d: "m217 185.479-43.716 25.406a19.522 19.522 0 0 1 6.036-2.261c6.353-1.262 14.022.281 22.245 5.028a68.567 68.567 0 0 1 15.46 12.525 94.931 94.931 0 0 1 17.438 26.636 77.774 77.774 0 0 1 6.587 25.527l43.717-25.4a77.816 77.816 0 0 0-6.588-25.529 94.915 94.915 0 0 0-17.437-26.635 68.566 68.566 0 0 0-15.461-12.524c-8.223-4.747-15.891-6.29-22.245-5.029a19.533 19.533 0 0 0-6.036 2.256z",
    transform: "translate(332.543 83.266)",
    style: {
      fill: "#cddcfb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "woman sit"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2953"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2952"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3840",
    d: "M288.572 280.006c1.009.83 1.883 5.944-2.207 5.829-2.112-.059-3.946-1.493-5.776-2.646-1.044-.657-.52-1.793-1.6-2.345-4.992-2.557-11.387-3.948-10.467-9.981.1-.674.28-3.53.8-3.854.376-.234 2.488.511 2.962.59 4.569.757 5.162.778 5.916 1.294.125 3.428.676 4.025 2.552 5.151.869.519 7.059 5.337 7.82 5.962z",
    transform: "translate(340.615 90.406)",
    style: {
      fill: "#ffbfa2"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2954"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3841",
    d: "M288.057 298.535V294.8h1.027l-.265 3.772a.533.533 0 0 1-.762-.037z",
    transform: "translate(342.28 92.767)",
    style: {
      fill: "#283032"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3842",
    d: "M294.883 298.063a27.284 27.284 0 0 1 1.6 2.277.97.97 0 0 1 .2.621.747.747 0 0 1-.383.527 1.793 1.793 0 0 1-.643.194 6.483 6.483 0 0 1-2.643-.146 2.788 2.788 0 0 1-1.283-.657 4.112 4.112 0 0 1-.833-1.883 2.569 2.569 0 0 0-1.1-1.7c-.17-.087-.356-.138-.529-.218a2.366 2.366 0 0 1-.824-3.4c.385-.605.9-.564 1.5-.309a5.737 5.737 0 0 1 1.665 1.45c.077.075.157.148.241.216.576.468-.257-2.128.085-1.427a24.027 24.027 0 0 0 2.947 4.455z",
    transform: "translate(342.28 92.631)",
    style: {
      fill: "#283032"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3843",
    d: "M291.367 273.909a2.6 2.6 0 0 1 .809 1.588 46.862 46.862 0 0 1 .186 7.187c-.037 2.136-.465 4.247-.47 6.385a45.834 45.834 0 0 0 .466 6.435c.159.7-1.138 1.2-1.781.873-.445-.226-1.321-.778-1.373-1.274-.3-2.806-1.768-5.344-2.462-8.08a16.713 16.713 0 0 1-.184-7.071c.36-1.909.472-4.32 1.859-5.821a2.019 2.019 0 0 1 2.95-.222z",
    transform: "translate(342.128 90.949)",
    style: {
      fill: "#ee9c76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3844",
    d: "M292.023 293.112a8.167 8.167 0 0 0 .28 1.4 6.456 6.456 0 0 0 .159.629 4.5 4.5 0 0 0 .321.643 13.17 13.17 0 0 0 .717 1.111 7.957 7.957 0 0 1 .756 1.015c.13.263.289.8-.016 1a.79.79 0 0 1-.6.063 3.267 3.267 0 0 1-1.55-.979 9.978 9.978 0 0 0-1.35-1.274c-.333-.228-.707-.394-1.039-.627a2.339 2.339 0 0 1-1.125-2.011c.042-.438.318-.8.341-1.228a2.681 2.681 0 0 1 .23-1.266z",
    transform: "translate(342.324 92.494)",
    style: {
      fill: "#ee9c76"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2955"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3845",
    d: "M291.785 302.275a2.159 2.159 0 0 1 .036.365 1.412 1.412 0 0 1-.438 1.107 1.333 1.333 0 0 1-.919.289 3.573 3.573 0 0 1-2.681-1.909c-.679-1.122-.92-2.6-1.865-3.539-.219-.217-.48-.393-.682-.625a2.313 2.313 0 0 1-.523-1.342 1.919 1.919 0 0 1 .248-1.2 1.634 1.634 0 0 1 2.08-.389c.5.248 1.236.1 1.607.54a4.881 4.881 0 0 1 .677 1.129 32.543 32.543 0 0 1 2.221 4.748 4.935 4.935 0 0 1 .239.826z",
    transform: "translate(341.996 92.77)",
    style: {
      fill: "#3a4648"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3846",
    d: "M286.589 273.371c.788 5.333.4 11.935 1.136 17.274a81.362 81.362 0 0 0 2.016 8.768c.281.739-1.708 1.168-2.456.912-.517-.176-1.431-2.185-1.562-2.716-.747-3-2.734-5.537-3.9-8.4A20.5 20.5 0 0 1 280.8 278.7a2.046 2.046 0 0 1 .961-1.6z",
    transform: "translate(341.641 90.95)",
    style: {
      fill: "#f8b495"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3847",
    d: "M288.069 295.314c.159.342.669.3.778.655.122.4.464 1.422.64 1.8a5.423 5.423 0 0 1 .484 1.624 1.049 1.049 0 0 1-.452 1.046 1.029 1.029 0 0 1-1.3 0 5.551 5.551 0 0 1-1.166-1.192 7.4 7.4 0 0 1-.835-1.263 10.527 10.527 0 0 1-1.036-2.856 6.659 6.659 0 0 1 .037-1.383 4.584 4.584 0 0 1 .552.274l2.132 1.143c.268.151.027-.145.166.152z",
    transform: "translate(342.035 92.679)",
    style: {
      fill: "#f8b495"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2959"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2957"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3848",
    d: "M277.8 260.956c-.97-2.26-1.887-5.24-3.161-8.949a10.08 10.08 0 0 1-.553-3.129 6.043 6.043 0 0 1 .826-2.95 1.716 1.716 0 0 1 1.038-1.01 1.6 1.6 0 0 1 1.237.427c2.135 1.615 2.506 3.811 3 6.36a77.6 77.6 0 0 1 .586 7.886c.037.459.59 4.63-.9 3.959a5.159 5.159 0 0 1-2.073-2.594z",
    transform: "translate(341.095 88.534)",
    style: {
      fill: "#1499fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3849",
    d: "M278.072 257.787c.515-.4 1.123-2.645 1.444-2.15.221.342 2.724 4.275 3.767 5.714a26.912 26.912 0 0 0-3.767 3.264c-1.559-1.889-2.962-3.972-2.944-5.289.01-.666.818-1.013 1.5-1.539z",
    transform: "translate(341.306 89.439)",
    style: {
      fill: "#1499fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3850",
    d: "m264.016 261.836.012.012c.117.913.194 1.832.227 2.751q-.065-1.386-.239-2.763z",
    transform: "translate(340.241 89.971)",
    style: {
      fill: "#f3a984"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3851",
    d: "M264.236 264.383q.041.841.04 1.684l-.031-.015q.022-.834-.009-1.669z",
    transform: "translate(340.26 90.187)",
    style: {
      fill: "#f3a984"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2956"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3852",
    d: "M290.826 281.326a23.832 23.832 0 0 1-2.692 1.6 11.482 11.482 0 0 1-5.721 1.483c-1.578-.151-2.765-1.854-4.2-2.425-4.5-1.788-6.4-2.187-9.313-4.5-2.836-2.252-3.063-5.723-2.591-9.159.1-.738.175-1.486.316-2.214.077-.4.159-1.187.55-1.43.452-.281 2.993.616 3.564.711 5.5.911 7.532-1.124 8.439-.5 2.355 1.6 4.8 3.06 7.267 4.478 1.923 1.107 3.762 2.277 5.638 3.461a6.263 6.263 0 0 1 2.08 2.632 3.7 3.7 0 0 1 .071 3.165 4.389 4.389 0 0 1-1.134 1.072c-.75.553-1.5 1.106-2.274 1.626z",
    transform: "translate(340.419 90.207)",
    style: {
      fill: "#021b74"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3853",
    d: "M266.83 246.072a20.737 20.737 0 0 1 4-1.249c.217-.049.435-.1.653-.142a8.031 8.031 0 0 1 4.873.4l.05.024v10h-9.58z",
    transform: "translate(340.48 88.498)",
    style: {
      fill: "#f3a984"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3854",
    d: "M262.849 250.433c.207-2.3 2.816-3.566 4.732-4.725.275 1.887 1.1 3.622 3.019 4.262a2.483 2.483 0 0 0 2.9-.87c1-1.339.893-3.021.721-4.716a9.391 9.391 0 0 1 2.476.7 4.573 4.573 0 0 1 1.863 1.561 5.572 5.572 0 0 1 .435 1.867 13.572 13.572 0 0 0 .687 2.12c.349.835.92 1.6 1.22 2.449a5.267 5.267 0 0 1-.156 2.92 9.014 9.014 0 0 1-.577 1.264q-.495.97-.923 1.972a6.933 6.933 0 0 0-.581 1.9 6.623 6.623 0 0 0 .09 1.755c.245 1.593 1.373 3.695-.035 5.04a9.468 9.468 0 0 1-3.019 1.923 8.258 8.258 0 0 1-1.595.472 8.765 8.765 0 0 1-6.681-1.607c-.2-.156-.31-.232-.354-.447a5.722 5.722 0 0 1 0-.58 17.05 17.05 0 0 1 .106-1.772 16.624 16.624 0 0 0-.136-3.7c-.622-3.7-3.05-6.842-4.055-10.451a3.751 3.751 0 0 1-.137-1.337z",
    transform: "translate(340.141 88.49)",
    style: {
      fill: "#13b7fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3855",
    d: "M263.58 248.312c2.824.59 2.408 5.825 3.9 8.11 1.1 1.788 3.437 1.376 5.361 1.513a3.626 3.626 0 0 0-2.062 3.161 35.045 35.045 0 0 0 .665 8.886 8.18 8.18 0 0 1-4.013-1.588c-.2-.156-.31-.232-.354-.447a5.721 5.721 0 0 1 0-.58 17.05 17.05 0 0 1 .106-1.772 16.624 16.624 0 0 0-.136-3.7c-.622-3.7-3.05-6.842-4.055-10.451a3.751 3.751 0 0 1-.138-1.344 3.409 3.409 0 0 1 .726-1.788z",
    transform: "translate(340.141 88.823)",
    style: {
      fill: "#1499fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3856",
    d: "M271.71 249.878c.118.382 1.735.668 1.926.628s.309-.3.374-.456a9.953 9.953 0 0 0 .756-3.654 1.438 1.438 0 0 0-.37-1.115 1.092 1.092 0 0 0-1.1-.154c-.366.159-.231.184-.1.517.468 1.195-.666 3.621-1.486 4.234z",
    transform: "translate(340.894 88.546)",
    style: {
      fill: "#1499fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3857",
    d: "M271.339 235.44a3.644 3.644 0 0 1-6.974 1.481 3.513 3.513 0 0 1-.319-1.481 3.651 3.651 0 0 1 3.646-3.646 3.658 3.658 0 0 1 3.647 3.646z",
    transform: "translate(340.244 87.422)",
    style: {
      fill: "#242a31"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2958"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3858",
    d: "M267.676 246.47c-.1 3.532 6.06 3.592 5.971.27-.123-4.63-.385-5.162-2.415-5.879a5.533 5.533 0 0 0-1.724-.36c-2.143-.042-1.313 1.127-1.232 1.943.239 2.419-.562 2.756-.6 4.026z",
    transform: "translate(340.551 88.161)",
    style: {
      fill: "#f3a984"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3859",
    d: "M267.676 246.47c.038-1.271.839-1.607.6-4.026-.08-.816-.91-1.985 1.232-1.943a5.533 5.533 0 0 1 1.724.36c2 .707 2.284 1.237 2.409 5.69-1.705-.176-3.212-2.2-4.95-1a3.364 3.364 0 0 0-.99 1.384 2.849 2.849 0 0 1-.025-.465z",
    transform: "translate(340.551 88.161)",
    style: {
      fill: "#ee9c76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3860",
    d: "M270.294 244.737c-.178-.15-.353-.3-.523-.461a9.172 9.172 0 0 1-1.666-1.88 5.966 5.966 0 0 1 .494-7.158 5.423 5.423 0 0 1 5.275-1.423 7.746 7.746 0 0 1 1.433.592 3.794 3.794 0 0 1 1.1.762 3.571 3.571 0 0 1 .491.728 3.878 3.878 0 0 1 .382.912c.359 1.443-.6 2.918-.052 4.342.119.31.3.6.409.912a1.139 1.139 0 0 1-.031.96c-.165.267-.381.4-.478.7-.131.4-.22.83-.335 1.239a5.819 5.819 0 0 1-.476 1.3c-.552.989-1.352 1.051-2.34.663a13.323 13.323 0 0 1-3.683-2.188z",
    transform: "translate(340.507 87.577)",
    style: {
      fill: "#ffbfa2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3861",
    d: "M274.053 242.169c-.44-1.764-2.5-2.352-3.379-3.821a11.153 11.153 0 0 1-1.5-3.747 5.442 5.442 0 0 1 4.524-.786 7.746 7.746 0 0 1 1.433.592 3.794 3.794 0 0 1 1.1.762 3.574 3.574 0 0 1 .491.728 3.88 3.88 0 0 1 .382.912c.359 1.443-.6 2.918-.052 4.342.119.31.3.6.409.912a1.139 1.139 0 0 1-.031.96c-.165.268-.381.4-.478.7-.131.4-.22.83-.335 1.239a5.838 5.838 0 0 1-.476 1.3 1.471 1.471 0 0 1-1.531.873c-1.116-1.335-.15-3.335-.557-4.966z",
    transform: "translate(340.679 87.577)",
    style: {
      fill: "#ffbfa2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3862",
    d: "M268.6 235.162a5 5 0 0 1 .751-.637 11.151 11.151 0 0 0 1.5 3.747c.881 1.469 2.939 2.057 3.379 3.821.407 1.626-.56 3.627.555 4.965a3.05 3.05 0 0 1-.809-.21 13.323 13.323 0 0 1-3.678-2.187c-.178-.15-.353-.3-.523-.461a9.172 9.172 0 0 1-1.666-1.88 5.966 5.966 0 0 1 .491-7.158z",
    transform: "translate(340.507 87.654)",
    style: {
      fill: "#f8b495"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3863",
    d: "M266.077 238.058c.1-2.809.994-3.219 1.993-4.18a5.21 5.21 0 0 1 3.771-1.218 7.851 7.851 0 0 1 3.876 1.237l.138.088a3.061 3.061 0 0 1 1.64 2.171c.038.287.168.9-.061 1.13-.191.189-1.164.105-1.359.107-.6.008-1.121-.426-1.742-.331a1.222 1.222 0 0 0-.971.866 3.752 3.752 0 0 1-.226 1.034c-.205.328-.627.439-.91.7-.572.526-.523 1.584-1.216 1.933a2.1 2.1 0 0 1-1.378-.042c-.459-.1-1.033-.088-1.283.31-.088.139.038.284.029.449-.012.219.058 1.081.058 1.081a1 1 0 0 1-.292-.068 2.9 2.9 0 0 1-.807-.9 7.184 7.184 0 0 1-1.26-4.367z",
    transform: "translate(340.415 87.495)",
    style: {
      fill: "#37404a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3864",
    d: "M268.5 239.984c-.958-.064-1.2 1.125-.543 2.044a4.743 4.743 0 0 0 .782.719c1.717 1.462 2.148-.119 1.6-.617-1.266-1.156-.639-2.064-1.839-2.146z",
    transform: "translate(340.544 88.117)",
    style: {
      fill: "#f8b495"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3865",
    d: "M269.048 242.089c-.111-.1-1.2-.745-.459-1.185a.329.329 0 0 1 .468.278c.016.113-.02.228 0 .342a.507.507 0 0 0 .074.188c.1.158.427.309.362.54-.06.203-.382-.106-.445-.163z",
    transform: "translate(340.607 88.192)",
    style: {
      fill: "#f3a984"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3866",
    d: "M272.146 249.855a8.689 8.689 0 0 1-1.711 1.507c-.2.118-.38.28-.6.159a9.086 9.086 0 0 1-3.249-4.41 1.828 1.828 0 0 1 .5-1.45c.059-.054.719-.318.8-.351a8.172 8.172 0 0 0 .375 1.7c.639 1.523 2.311 2.301 3.885 2.845z",
    transform: "translate(340.458 88.569)",
    style: {
      fill: "#1499fc"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2967"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2966"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2965"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2964",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2960"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3867",
    d: "M296.3 272.2v1.435l-16.588 9.64v-1.435z",
    transform: "translate(341.571 90.851)",
    style: {
      fill: "#37404a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2961"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3868",
    d: "M280.516 281.555v1.435l-10.292-5.942v-1.435z",
    transform: "translate(340.767 91.14)",
    style: {
      fill: "#30383a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2963"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2962"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3869",
    d: "m297.1 272.669-16.588 9.64-10.292-5.943 16.588-9.64z",
    transform: "translate(340.767 90.386)",
    style: {
      fill: "#37404a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3870",
    d: "m283.609 271.468-4.507 2.6-2.459-1.42 4.507-2.6z",
    transform: "translate(341.312 90.668)",
    style: {
      fill: "#0d1315"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3871",
    d: "m274.385 277.773 15.15-8.8 5.411 3.131-15.15 8.8z",
    transform: "translate(341.12 90.576)",
    style: {
      fill: "#0d1315"
    }
  }))))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2968"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3872",
    d: "M262.356 264.68c-.473-2.463-.737-5.63-1.2-9.6a10.3 10.3 0 0 1 .13-3.237 6.167 6.167 0 0 1 1.467-2.757 1.753 1.753 0 0 1 1.254-.781 1.637 1.637 0 0 1 1.139.7 11.394 11.394 0 0 1 2.292 7.651c-.063 2.462.219 4.924.136 7.394a7.156 7.156 0 0 1-.116 1.435c-.536 2.2-2.275 3.228-3.614 2.234a5.252 5.252 0 0 1-1.488-3.039z",
    transform: "translate(339.992 88.823)",
    style: {
      fill: "#15d9fd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2972"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2970"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2969"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3873",
    d: "M284 269.022a7.08 7.08 0 0 0 .832 1.2c.214.211.064-.679.366-.667.459.018.957.31 1.3.01a4.268 4.268 0 0 0 .758-.793 1.648 1.648 0 0 0 .317-1.031.791.791 0 0 0-.127-.4 1.144 1.144 0 0 0-.2-.209l-1.222-1.083a1.7 1.7 0 0 0-.283-.215 1.1 1.1 0 0 0-.462-.12 1.929 1.929 0 0 0-1.488.656 1.8 1.8 0 0 0-.456.743c-.051.226.106.477.178.688a10.57 10.57 0 0 0 .487 1.221z",
    transform: "translate(341.879 90.299)",
    style: {
      fill: "#f8b495"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3874",
    d: "m283.465 267.8-.088 1.787a2.423 2.423 0 0 0 .033.687 4.872 4.872 0 0 0 .181.5c.055.154.093.313.161.461a2.545 2.545 0 0 0 1.06.994 1.6 1.6 0 0 0 .544.251c.126.023.285-.005.331-.125a.338.338 0 0 0 0-.18 1.176 1.176 0 0 0-.175-.494c-.127-.17-.334-.264-.476-.422a1.076 1.076 0 0 1-.131-1.04c.113-.348.321-.656.468-.993a1.305 1.305 0 0 0 .065-1.063 1.389 1.389 0 0 0-.223-.316 2.13 2.13 0 0 0-.7-.559 1.113 1.113 0 0 0-.753-.073c-.277.085-.284.326-.297.585z",
    transform: "translate(341.882 90.424)",
    style: {
      fill: "#f8b495"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3875",
    d: "M286.087 268.575c-.333-.155-1.014.576-1.074.77-.143.47.338.076.949 1.02a2.819 2.819 0 0 1 .432.873c.054.232.079.521.3.618a.394.394 0 0 0 .466-.179c.051.331.552.064.651-.27.19-.644.681-.058.756-1.186l.186.079c.757-.622-.822-2.432-1.509-3.139-1.216-1.247-1.493.71-1.157 1.414z",
    transform: "translate(342.02 90.388)",
    style: {
      fill: "#f8b495"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3876",
    d: "M279.286 264.162a26.91 26.91 0 0 1 3.767-3.264 31.386 31.386 0 0 1 3.042 5.079c.621 1.371-2.026 2.651-2.663 1.945a41.887 41.887 0 0 1-4.146-3.76z",
    transform: "translate(341.536 89.891)",
    style: {
      fill: "#1499fc"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2971"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3877",
    d: "M276.9 273.543a7.911 7.911 0 0 1 1.3.973c.228.246-.758.046-.756.381 0 .512.307 1.078-.04 1.453a4.842 4.842 0 0 1-.912.813 1.845 1.845 0 0 1-1.161.314.9.9 0 0 1-.442-.157 1.337 1.337 0 0 1-.226-.231l-1.156-1.4a1.764 1.764 0 0 1-.229-.323 1.2 1.2 0 0 1-.115-.517 2.144 2.144 0 0 1 .789-1.633 2.013 2.013 0 0 1 .844-.478c.254-.048.527.138.759.226a11.884 11.884 0 0 1 1.345.579z",
    transform: "translate(341.017 90.894)",
    style: {
      fill: "#ffbfa2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3878",
    d: "m275.562 272.893 1.993-.028a2.719 2.719 0 0 1 .763.062c.191.054.368.15.552.222.169.067.345.116.508.2a2.846 2.846 0 0 1 1.064 1.219 1.754 1.754 0 0 1 .258.615c.02.141-.017.317-.152.362a.362.362 0 0 1-.2-.007 1.29 1.29 0 0 1-.542-.214c-.185-.148-.28-.383-.451-.547a1.2 1.2 0 0 0-1.153-.187c-.393.112-.744.333-1.124.482a1.455 1.455 0 0 1-1.186.031 1.543 1.543 0 0 1-.343-.261 2.38 2.38 0 0 1-.594-.8 1.233 1.233 0 0 1-.052-.841c.097-.301.368-.301.659-.308z",
    transform: "translate(341.16 90.906)",
    style: {
      fill: "#ffbfa2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3879",
    d: "M274.517 275.711a3.144 3.144 0 0 1-2.32-.855c-1.547-1.147-9.105-7.417-9.614-10.336-.128-.737.705-1.128 1.362-1.717.495-.445 3.076.085 3.538.629.726.853 6.289 6.486 8.2 9.309a2.237 2.237 0 0 1 .491 1.229c-.009.711-1.012 1.605-1.657 1.741z",
    transform: "translate(340.118 90.038)",
    style: {
      fill: "#15d9fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3880",
    d: "M276.324 275.842c-.159-.375.68-1.107.9-1.165.529-.141.072.38 1.1 1.1a3.15 3.15 0 0 0 .956.514c.257.069.577.108.677.355a.437.437 0 0 1-.217.513c.366.069.049.616-.325.713-.726.188-.091.757-1.351.8l.082.21c-.722.818-2.676-1.011-3.437-1.8-1.346-1.408.844-1.64 1.615-1.24z",
    transform: "translate(341.112 91.058)",
    style: {
      fill: "#ffbfa2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2987"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2986",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2976"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2975"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3881",
    d: "m297.227 263.066 1.241.721a.334.334 0 0 0-.336.034l-1.241-.721a.334.334 0 0 1 .336-.034z",
    transform: "translate(343.03 90.072)",
    style: {
      fill: "#3a4648"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2974",
    style: {
      clipPath: "url(#sq2nwtxctac)"
    },
    transform: "translate(639.921 353.107)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2973",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3882",
    d: "m298.132 263.821-1.241-.721a.5.5 0 0 1 .144-.057l1.241.721a.46.46 0 0 0-.144.058z",
    transform: "translate(-296.891 -263.034)",
    style: {
      fill: "#3a4648"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3883",
    d: "m298.265 263.764-1.241-.721a.265.265 0 0 1 .183.019l1.241.721a.266.266 0 0 0-.183-.02z",
    transform: "translate(-296.88 -263.035)",
    style: {
      fill: "#3a4648"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3884",
    d: "m298.434 263.781-1.241-.721h.008l1.241.721h-.008z",
    transform: "translate(-296.865 -263.033)",
    style: {
      fill: "#3a4648"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2978"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2977"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3886",
    d: "m283.71 272.909-1.241-.721 15.645-9.093 1.241.721z",
    transform: "translate(341.807 90.077)",
    style: {
      fill: "#3a4648"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2982"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2981"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3887",
    d: "m283.274 273.014-1.241-.72a1.043 1.043 0 0 1 .473-.817l1.241.721a1.037 1.037 0 0 0-.473.816z",
    transform: "translate(341.77 90.788)",
    style: {
      fill: "#3a4648"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2980",
    style: {
      clipPath: "url(#lk26392yqad)"
    },
    transform: "translate(623.803 362.265)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2979"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3888",
    d: "m283.5 272.4-1.24-.721a.852.852 0 0 1 .23-.2l1.241.721a.872.872 0 0 0-.231.2z",
    transform: "translate(-282.014 -271.477)",
    style: {
      fill: "#353f41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3889",
    d: "m283.35 272.643-1.24-.72a1.112 1.112 0 0 1 .159-.259l1.24.721a1.165 1.165 0 0 0-.159.258z",
    transform: "translate(-282.026 -271.461)",
    style: {
      fill: "#353f41"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2983"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3891",
    d: "M299.59 263.765c.261-.152.473-.03.473.27l-3.764 8.89-16.592 9.64 3.7-8.905a1.3 1.3 0 0 1 .533-.8z",
    transform: "translate(341.572 90.128)",
    style: {
      fill: "#37404a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2985"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2984"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3892",
    d: "m279.8 281.87-1.241-.721 3.848-9.247 1.241.721z",
    transform: "translate(341.475 90.824)",
    style: {
      fill: "#30383a"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2989"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2988"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3893",
    d: "m91.251 213.744 8.2-4.766a8.615 8.615 0 0 1-.836.421c-.089.039-.181.074-.271.11a8.91 8.91 0 0 1-.548.2 9.366 9.366 0 0 1-.814.222c-.12.027-.238.062-.36.085-.156.029-.318.047-.476.069-.2.027-.393.056-.6.072-.115.009-.233.012-.35.016-.238.011-.477.016-.721.011a12.749 12.749 0 0 1-1.295-.093c-.02 0-.039 0-.059-.007a12.194 12.194 0 0 1-1.084-.2l-.228-.05c-.379-.089-.762-.19-1.15-.312l-8.2 4.765c.066.022.131.041.2.061q.369.112.734.2c.074.018.146.033.22.049s.151.035.227.051c.1.022.205.048.306.067.257.051.511.092.764.127h.014l.059.005c.247.033.493.059.733.076.082.005.163 0 .244.008.106.005.213.009.318.011s.2.01.294.01c.145 0 .285-.014.429-.021.116-.005.234-.008.349-.016.047 0 .1 0 .142-.007.155-.014.3-.044.455-.066s.319-.039.475-.068c.034-.007.069-.009.1-.015.089-.017.17-.05.258-.071.276-.063.548-.135.813-.222.057-.018.119-.028.177-.048.127-.044.248-.1.372-.151.09-.037.181-.071.27-.11a8.737 8.737 0 0 0 .839-.413z",
    transform: "translate(324.837 85.487)",
    style: {
      fill: "url(#z7sg9j6bia)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3894",
    d: "m103.212 193.986-8.2 4.765L120.2 202.1l8.2-4.765z",
    transform: "translate(325.902 84.215)",
    style: {
      fill: "url(#ytk1opx8zae)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3895",
    d: "M163.091 255.426c.131-.659.255-1.329.375-2.007l.065-.349.005-.028q.2-1.163.382-2.366l-8.2 4.766q-.181 1.2-.382 2.365l-.071.382c-.12.677-.244 1.346-.374 2-.055.274-.114.541-.171.814-.1.5-.208 1-.318 1.486-.062.273-.127.54-.191.81a82.603 82.603 0 0 1-.374 1.538q-.109.426-.221.847c-.128.483-.26.959-.394 1.43-.074.257-.146.515-.222.769-.22.743-.446 1.475-.681 2.188l-.033.105a61.89 61.89 0 0 1-.766 2.184q-.2.548-.408 1.082l-.158.416q-.309.781-.627 1.535l-.138.316c-.17.4-.342.788-.516 1.172-.075.165-.151.325-.226.488q-.205.439-.413.869c-.135.277-.269.549-.406.819-.122.241-.243.481-.367.717q-.207.4-.417.782c-.125.231-.251.461-.376.687-.142.254-.286.5-.431.751a41.817 41.817 0 0 1-.827 1.375c-.131.21-.261.421-.394.627-.145.226-.292.446-.438.666-.136.2-.27.408-.407.606-.149.217-.3.427-.448.639-.138.193-.274.387-.412.576-.152.207-.3.409-.458.611-.139.183-.278.369-.418.548-.154.2-.309.389-.465.582-.14.175-.281.351-.422.522-.157.189-.316.372-.474.557-.141.165-.282.331-.424.491-.159.181-.32.356-.482.532-.142.156-.283.314-.426.465-.162.172-.324.338-.487.506-.142.146-.284.3-.427.439-.164.164-.329.322-.494.482-.142.139-.285.279-.428.414-.165.156-.332.306-.5.457-.142.13-.284.263-.426.389-.168.149-.337.292-.507.437-.14.12-.281.244-.421.362-.169.141-.34.277-.509.413-.14.114-.281.23-.421.341-.171.134-.342.263-.512.392-.139.106-.278.215-.415.317-.176.13-.35.254-.526.38-.133.1-.266.193-.4.286-.185.129-.371.253-.557.377-.121.081-.243.166-.365.246-.214.14-.426.273-.639.408-.092.057-.184.118-.276.175q-.456.283-.909.546l8.2-4.766q.452-.262.909-.546c.091-.055.183-.117.274-.175.214-.133.426-.267.64-.408.122-.079.243-.165.365-.246.185-.125.371-.247.557-.378.132-.092.266-.191.4-.286.176-.126.35-.248.526-.379.138-.1.277-.212.415-.317.17-.13.341-.258.512-.393.14-.111.281-.227.421-.341.169-.137.338-.272.509-.413.141-.118.282-.243.424-.365.167-.143.335-.285.5-.434.144-.128.287-.261.431-.393.165-.151.33-.3.495-.455.143-.135.285-.276.429-.414.165-.159.33-.318.494-.482.143-.143.286-.293.43-.44.162-.167.323-.332.484-.5.144-.153.287-.312.431-.469.159-.176.319-.349.478-.528.142-.162.284-.33.427-.5.156-.182.314-.364.47-.552.142-.171.283-.348.425-.524.154-.192.309-.383.463-.58.14-.179.279-.365.418-.548.153-.2.306-.4.457-.61.139-.19.277-.385.414-.579.15-.21.3-.42.446-.636.138-.2.273-.4.409-.609.146-.22.292-.439.436-.664l.14-.213c.086-.136.17-.279.256-.417.148-.238.294-.475.44-.718.129-.216.258-.436.385-.656.144-.247.287-.5.43-.75q.19-.34.378-.689a51.493 51.493 0 0 0 .785-1.499c.136-.269.27-.54.4-.816.059-.12.118-.235.176-.357.081-.169.159-.344.239-.516s.151-.321.225-.484q.262-.578.516-1.172c.047-.106.093-.21.139-.319q.319-.752.626-1.533c.054-.137.106-.279.161-.418.11-.282.219-.562.327-.85.027-.074.052-.154.08-.229.261-.713.519-1.437.765-2.184l.034-.105c.235-.713.461-1.445.681-2.189.027-.093.057-.18.086-.275.047-.162.09-.332.136-.495q.2-.706.4-1.432a84.987 84.987 0 0 0 .595-2.385c.044-.191.093-.372.138-.564l.052-.244c.11-.488.214-.988.318-1.488.058-.263.117-.531.171-.805z",
    transform: "translate(328.983 89.025)",
    style: {
      fill: "url(#9a2by5o0faf)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3896",
    d: "m161.725 251.987-.16-.149q-.646-.615-1.269-1.27l-.17-.179a38.62 38.62 0 0 1-1.2-1.34l-.168-.2q-.57-.677-1.115-1.383l-.238-.311c-.26-.344-.513-.7-.765-1.051-.159-.225-.32-.448-.476-.676s-.292-.444-.437-.666c-.321-.49-.635-.987-.936-1.491-.168-.28-.336-.56-.5-.843q-.187-.329-.37-.661a44.645 44.645 0 0 1-.806-1.529v-.009q-.456-.916-.864-1.849l-.042-.1q-.382-.879-.724-1.768a5.96 5.96 0 0 1-.069-.187q-.322-.854-.6-1.713l-.071-.221q-.27-.849-.5-1.7-.033-.117-.062-.234-.22-.848-.394-1.692l-.046-.222q-.169-.851-.289-1.692l-.028-.2q-.116-.859-.178-1.705c0-.049-.009-.1-.012-.148-.041-.6-.064-1.2-.062-1.8 0-.345.012-.683.028-1.019 0-.1.012-.2.017-.292q.023-.356.056-.7l.034-.332c.026-.226.057-.447.09-.668.016-.1.029-.207.047-.309.053-.316.112-.626.179-.93l-8.2 4.766q-.091.41-.165.833l-.014.1c-.017.1-.03.206-.046.309-.024.153-.05.3-.069.46-.008.068-.013.139-.021.208-.013.11-.024.221-.035.332s-.023.2-.031.3c-.011.131-.016.266-.024.4-.007.1-.014.193-.018.291 0 .048-.007.1-.009.144q-.018.408-.02.827v.049c0 .266 0 .533.011.8.009.285.022.573.04.86 0 .044.008.089.011.133l.012.148c.014.2.027.389.047.586.027.292.061.585.1.879.01.08.024.161.035.241l.027.2c.022.151.041.3.065.452.048.3.1.609.157.915l.066.324.046.223c.026.126.049.252.077.378q.1.474.22.948c.03.121.065.244.1.366.021.079.04.157.062.235.03.116.06.233.092.35q.132.475.278.952c.04.131.085.264.127.395.024.075.047.149.072.222.034.1.065.208.1.313q.155.459.32.917c.059.162.12.322.181.483l.071.187c.024.062.052.143.08.215.114.292.23.583.351.872.093.227.192.453.291.679l.042.1.034.078c.131.3.266.592.4.886s.28.588.425.88l.007.012v.005q.275.553.566 1.1c.076.143.159.282.237.424q.182.332.37.661c.09.157.174.317.265.473.074.126.158.245.233.371q.454.757.937 1.492c.091.14.174.285.266.423.055.081.114.16.169.24.157.23.319.455.48.68.149.209.291.423.444.629.1.142.214.28.32.42.078.1.156.207.236.31s.146.2.221.291q.347.441.7.871c.063.075.127.146.19.221l.168.2c.108.127.215.255.324.38q.348.4.7.78c.056.061.114.119.17.179l.173.18c.128.134.255.271.384.4q.379.386.766.757l.117.11.162.15c.168.158.336.318.507.472q.4.358.8.7l.065.055 8.2-4.766a32.858 32.858 0 0 1-1.365-1.217z",
    transform: "translate(329.801 86.487)",
    style: {
      fill: "url(#nnpo739jdag)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3897",
    d: "m118.232 201.836 8.2-4.765 25.123 25.7-8.2 4.765z",
    transform: "translate(327.872 84.476)",
    style: {
      fill: "url(#lwn02c96hah)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3898",
    d: "m121.268 201.726 25.122 25.7a19.785 19.785 0 0 0-.451 4.253c-.028 9.744 5.9 21.458 13.926 28.2-6.333 42.3-32.948 47.007-38.9 47.531a176.307 176.307 0 0 1-16.649-25.418c-8.128-14.919-18.366-38.416-21.856-66.8 8.042 2.54 14.013-2.307 14.041-12.052a27.5 27.5 0 0 0-.426-4.759z",
    transform: "translate(324.837 84.587)",
    style: {
      fill: "url(#yw15qjfm6ai)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3899",
    d: "M120.75 303.048a176.216 176.216 0 0 1-14.415-22.414 185.129 185.129 0 0 1-20.674-61.328c8.143 1.142 13.618-4.745 13.646-14.716a30.4 30.4 0 0 0-.09-2.328l21.815 2.9 21.761 22.262c-.065.717-.1 1.462-.1 2.216-.028 9.971 5.4 22.152 13.519 30.4-6.368 35.773-28.548 41.954-35.459 43.011m.284-98.566-22.4-2.976.018.255c.075.854.112 1.7.11 2.511-.028 9.8-5.456 15.543-13.5 14.3l-.218-.031.038.283a186.318 186.318 0 0 0 20.851 62.007A176.9 176.9 0 0 0 120.6 303.6l.144.189.15-.018c6.8-.993 29.5-7.075 35.9-43.541l.044-.237-.217-.219c-8.031-8.04-13.409-20.021-13.38-29.82a23.784 23.784 0 0 1 .123-2.378l.02-.232-22.247-22.76-.1-.1",
    transform: "translate(325.056 84.853)",
    style: {
      fill: "url(#z7sg9j6bia)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2991"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3900",
    d: "M137.415 253.613c0-.049 0-.1-.007-.145s-.007-.1-.011-.145l-.016-.147c-.006-.05-.014-.1-.022-.15v-.008c-.009-.048-.016-.1-.025-.144l-.033-.156-.036-.157c-.013-.057-.027-.105-.042-.158l-.036-.124v-.01l-.007-.025-.05-.155c-.017-.055-.035-.1-.053-.152s-.036-.1-.055-.148-.038-.1-.059-.145-.031-.074-.048-.111v-.008l-.01-.024c-.022-.049-.043-.1-.066-.144s-.05-.106-.076-.158l-.093-.18c-.031-.06-.07-.127-.106-.19l-.018-.034-.023-.039a7.255 7.255 0 0 0-.411-.624c-.043-.059-.088-.117-.132-.175s-.077-.1-.116-.142-.077-.091-.116-.136-.077-.087-.116-.129l-.023-.025-.01-.009c-.029-.033-.06-.064-.09-.1s-.084-.084-.126-.125-.088-.082-.132-.121l-.132-.117-.068-.055-.014-.011-.051-.042c-.043-.035-.088-.067-.132-.1s-.086-.063-.13-.093l-.127-.084c-.042-.028-.085-.053-.127-.078l-.029-.017-30.383-17.541a.859.859 0 0 0-.1-.054l-.124-.064-.121-.057-.12-.051-.122-.046-.023-.008h-.009c-.029-.011-.06-.021-.089-.029l-.125-.035c-.041-.011-.082-.02-.123-.027s-.088-.016-.131-.022-.059-.007-.088-.009h-.187c-.041 0-.105 0-.156.008s-.116.014-.172.025h-.009a1.526 1.526 0 0 0-.2.055 1.443 1.443 0 0 0-.242.112l-8.2 4.766a1.459 1.459 0 0 1 .443-.167h.005a1.763 1.763 0 0 1 .506-.026h.013a2.414 2.414 0 0 1 .555.12h.009a3.465 3.465 0 0 1 .605.279l30.383 17.542a4.635 4.635 0 0 1 .6.413l.015.012a5.78 5.78 0 0 1 .548.513l.01.01a7.084 7.084 0 0 1 .938 1.27l.017.033a7.233 7.233 0 0 1 .353.7v.01a6.57 6.57 0 0 1 .27.733v.011a5.591 5.591 0 0 1 .171.74 4.528 4.528 0 0 1 .059.728l-.067 23.683a3.338 3.338 0 0 1-.061.645v.017a2.4 2.4 0 0 1-.17.529v.008a1.788 1.788 0 0 1-.226.349c-.027.034-.053.07-.082.1a1.477 1.477 0 0 1-.327.269l8.2-4.766a1.457 1.457 0 0 0 .328-.27c.029-.031.055-.067.082-.1a1.64 1.64 0 0 0 .109-.135 1.684 1.684 0 0 0 .113-.205v-.019c.023-.049.044-.1.065-.152s.036-.1.052-.157.027-.1.04-.153l.013-.066v-.017l.013-.063a3.069 3.069 0 0 0 .045-.428c.002-.048 0-.1 0-.145v-.009l.067-23.683a.784.784 0 0 0 .004-.136z",
    transform: "translate(325.792 87.323)",
    style: {
      fill: "url(#uvsw05syhb)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3901",
    d: "M126.3 252.969a6.58 6.58 0 0 1 2.985 5.171l-.067 23.683c0 1.9-1.351 2.668-3 1.712l-30.382-17.54a6.58 6.58 0 0 1-2.991-5.175l.067-23.683c.005-1.9 1.351-2.668 3.009-1.71z",
    transform: "translate(325.718 87.695)",
    style: {
      fill: "url(#ok1z7ijpxaj)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3902",
    d: "M109.43 248.835a8.845 8.845 0 0 1 4.014 6.948 2.64 2.64 0 0 1-1.444 2.69l-.021 7.255c0 1.64-1.166 2.3-2.6 1.475a5.683 5.683 0 0 1-2.578-4.464l.021-7.255a8.349 8.349 0 0 1-1.427-4.349c.005-2.55 1.816-3.581 4.035-2.3z",
    transform: "translate(326.783 88.821)",
    style: {
      fill: "url(#l8drgwiulak)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2990"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3903",
    d: "m107.7 224.09.021-.1a7.475 7.475 0 0 1 .224-.831 6.443 6.443 0 0 1 .239-.611c.01-.02.016-.041.026-.061a5.276 5.276 0 0 1 .342-.618c.017-.028.038-.052.056-.079a4.824 4.824 0 0 1 .327-.431c.042-.05.087-.1.131-.144q.153-.163.319-.308c.046-.04.091-.081.138-.119a4.251 4.251 0 0 1 .492-.343l-3.527 2.05a4 4 0 0 0-.493.343c-.048.037-.092.078-.138.118a4.273 4.273 0 0 0-.319.309c-.044.048-.089.094-.131.144a4.53 4.53 0 0 0-.327.431c-.018.027-.039.051-.056.078l-.013.018a5.16 5.16 0 0 0-.321.583l-.008.017c-.01.021-.017.042-.026.062-.06.131-.118.264-.17.4-.025.067-.046.138-.068.207l-.042.125-.038.115a7.628 7.628 0 0 0-.113.434c-.012.051-.021.105-.031.157l-.021.1c-.01.053-.022.1-.031.157-.023.132-.043.267-.061.4-.009.076-.015.153-.023.23 0 .027-.007.053-.009.08l-.011.1a12.298 12.298 0 0 0-.034.809v.025l-.028 10.012a2.664 2.664 0 0 1-.047.492v.014a1.861 1.861 0 0 1-.129.4v.008a1.346 1.346 0 0 1-.171.266c-.021.026-.041.053-.063.078a1.133 1.133 0 0 1-.251.206l3.527-2.05a1.077 1.077 0 0 0 .251-.206.893.893 0 0 0 .063-.078 1.088 1.088 0 0 0 .082-.1 1.345 1.345 0 0 0 .086-.156v-.015a1.757 1.757 0 0 0 .119-.352l.01-.051v-.013l.009-.048c.007-.036.012-.073.017-.11s.008-.073.011-.111l.007-.107c.002-.036 0-.074 0-.111v-.006l.028-10.012c0-.323.017-.632.044-.932l.009-.08c.036-.267.076-.532.122-.785z",
    transform: "translate(326.606 86.459)",
    style: {
      fill: "url(#uvsw05syhb)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3904",
    d: "M129.114 238.273c-.007-.209-.016-.42-.029-.63-.007-.1-.016-.2-.024-.293 0-.041-.005-.082-.01-.125a20.436 20.436 0 0 0-.18-1.511v-.025l-.005-.029-.1-.605a24.184 24.184 0 0 0-.139-.681c-.018-.084-.039-.167-.059-.251l-.033-.143c-.023-.1-.044-.193-.068-.291q-.086-.347-.182-.693c-.048-.173-.1-.345-.151-.517-.009-.03-.017-.061-.027-.091s-.015-.055-.024-.082a32.742 32.742 0 0 0-.449-1.345c-.016-.042-.034-.086-.049-.129l-.039-.1c-.051-.136-.1-.271-.153-.407q-.124-.319-.256-.636a24.086 24.086 0 0 0-.2-.465l-.033-.076-.037-.086q-.14-.317-.289-.634c-.108-.231-.22-.462-.334-.691-.017-.036-.037-.071-.055-.106s-.047-.09-.069-.136c-.093-.181-.186-.363-.281-.544-.122-.228-.252-.45-.379-.675-.064-.114-.126-.229-.191-.341-.026-.044-.05-.091-.076-.136-.114-.194-.241-.38-.359-.572-.175-.282-.346-.566-.529-.843-.028-.043-.054-.09-.084-.133q-.392-.586-.808-1.152l-.021-.029q-.286-.387-.584-.766c-.156-.2-.316-.394-.476-.588l-.016-.021-.011-.014c-.166-.2-.335-.4-.506-.59s-.336-.379-.508-.564c-.027-.028-.054-.055-.081-.085l-.087-.091c-.122-.129-.244-.259-.368-.385a23.554 23.554 0 0 0-.551-.545c-.055-.053-.112-.1-.167-.156l-.13-.12c-.092-.086-.183-.174-.277-.258q-.288-.259-.581-.507c-.084-.07-.168-.137-.252-.206l-.132-.107c-.066-.053-.13-.108-.2-.161q-.285-.225-.573-.436l-.414-.3-.078-.055-.075-.053q-.273-.189-.552-.366a17.717 17.717 0 0 0-.552-.337l-.128-.075q-.207-.12-.413-.231c-.053-.029-.105-.054-.158-.082l-.212-.11-.164-.085c-.089-.044-.177-.084-.265-.125-.063-.03-.126-.061-.189-.089l-.075-.036q-.262-.117-.522-.22l-.026-.01c-.167-.067-.333-.13-.5-.188l-.071-.023c-.065-.023-.128-.042-.192-.063-.087-.028-.174-.06-.26-.086l-.135-.037c-.078-.023-.155-.043-.232-.064-.057-.015-.116-.034-.172-.048s-.126-.027-.189-.041-.153-.036-.23-.052l-.117-.026c-.074-.014-.145-.023-.219-.036s-.176-.03-.264-.043l-.09-.015c-.074-.01-.146-.014-.22-.022a6.91 6.91 0 0 0-.282-.029c-.026 0-.053-.007-.079-.008-.064 0-.126 0-.19-.007-.113-.005-.225-.011-.335-.011h-.09c-.049 0-.1.005-.143.007q-.208 0-.413.02c-.04 0-.082 0-.123.007s-.06.01-.09.013q-.309.031-.609.088l-.056.008h-.011a6.568 6.568 0 0 0-.831.229c-.024.009-.05.012-.074.021s-.038.016-.059.023a6.477 6.477 0 0 0-.347.142c-.055.024-.112.046-.166.071q-.251.117-.49.255l-3.527 2.05q.239-.138.49-.255c.054-.026.112-.048.167-.072.114-.05.229-.1.346-.141.043-.016.089-.029.132-.044a7 7 0 0 1 .831-.229l.067-.011c.2-.038.4-.066.608-.088.072-.008.142-.013.214-.02.136-.01.273-.016.413-.018.077 0 .155-.005.233 0 .111 0 .221.005.334.011.09 0 .18.008.271.014s.187.018.28.029.207.022.311.037c.088.013.176.029.264.044.112.018.223.038.336.062.076.015.153.034.23.051.12.027.24.057.361.089l.231.064c.131.038.264.079.4.123l.191.063c.189.065.379.135.571.212l.024.009c.2.079.4.166.6.257.062.028.125.06.187.089a16.96 16.96 0 0 1 1.214.633 19.1 19.1 0 0 1 1.307.831l.078.056q.6.42 1.184.892l.131.106q.565.464 1.112.972l.128.119q.555.522 1.088 1.087l.086.09q.566.607 1.105 1.253l.016.021q.547.661 1.062 1.358l.025.036c.307.417.6.845.888 1.28.183.277.355.561.529.843.145.235.3.466.434.706.066.113.128.228.192.342.228.4.45.807.66 1.218l.069.135c.252.5.491 1.007.715 1.517l.033.076q.325.75.609 1.51l.038.1c.191.517.366 1.038.524 1.558l.025.089q.226.752.4 1.5l.033.143c.118.514.22 1.027.3 1.536l.005.03c.081.515.143 1.028.186 1.536l.01.124c.04.509.063 1.013.061 1.511l-.028 10.012a2.577 2.577 0 0 1-.047.493v.013a1.8 1.8 0 0 1-.13.4v.007a1.352 1.352 0 0 1-.172.266.9.9 0 0 1-.063.078 1.092 1.092 0 0 1-.25.206l3.527-2.049a1.127 1.127 0 0 0 .25-.206c.023-.024.042-.052.064-.078s.058-.064.082-.1a1.529 1.529 0 0 0 .086-.156v-.016a1.727 1.727 0 0 0 .088-.235c.012-.041.022-.077.03-.117 0-.016.007-.033.011-.05v-.014c0-.016.008-.031.01-.048.007-.036.012-.072.016-.108s.009-.073.012-.111l.007-.108v-.116l.028-10.013c0-.2-.003-.396-.009-.592z",
    transform: "translate(326.601 85.954)",
    style: {
      fill: "url(#uvsw05syhb)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3905",
    d: "M112.859 218.169c7.211 4.164 13.06 14.29 13.037 22.581l-.028 10.012c0 1.45-1.03 2.035-2.292 1.306a5.02 5.02 0 0 1-2.283-3.948l.028-10.012c.016-5.39-3.786-11.975-8.476-14.682s-8.517-.527-8.532 4.862l-.028 10.012c0 1.452-1.031 2.035-2.293 1.306a5.016 5.016 0 0 1-2.281-3.947l.028-10.013c.023-8.29 5.909-11.64 13.12-7.477z",
    transform: "translate(326.3 86.114)",
    style: {
      fill: "url(#ojljp5rxqal)"
    }
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg3);
export default __webpack_public_path__ + "static/media/img3.14ee280fbc827605f520b4d2ed2ca60f.svg";
export { ForwardRef as ReactComponent };